import ae from "long";
import * as q from "protobufjs/minimal.js";
import "../billing/data.js";
import "../bills/cart.js";
import { Version as h } from "../common/client.js";
import "../common/countries.js";
import { Money as o } from "../common/currency.js";
import "../common/currency_codes.js";
import { DateTime as a, YearMonthDay as g } from "../common/time.js";
import "../feeplans/pricing/headline_fee_rates.js";
import "../posmodes/modes/model/mode.js";
import "../taxinator/service.js";
import "./common.js";
const u = "default" in q ? q.default : q;
var z;
(function(n) {
  n[n.DO_NOT_USE = 0] = "DO_NOT_USE", n[n.RETAIL = 1] = "RETAIL", n[n.RETAIL_RATE = 23] = "RETAIL_RATE", n[n.EMPLOYEE_MANAGEMENT = 4] = "EMPLOYEE_MANAGEMENT", n[n.TEAM_MANAGEMENT_PERMISSION_SETS_BASIC = 75] = "TEAM_MANAGEMENT_PERMISSION_SETS_BASIC", n[n.TEAM_MEMBER_ONBOARDING = 103] = "TEAM_MEMBER_ONBOARDING", n[n.APPOINTMENTS = 5] = "APPOINTMENTS", n[n.MARKETING = 2] = "MARKETING", n[n.MARKETING_SMS = 26] = "MARKETING_SMS", n[n.MARKETING_SMS_PREMIUM = 203] = "MARKETING_SMS_PREMIUM", n[n.LOYALTY = 3] = "LOYALTY", n[n.LOYALTY_INSIGHTS = 6] = "LOYALTY_INSIGHTS", n[n.DIRECTORY = 7] = "DIRECTORY", n[n.CUSTOMER_DIRECTORY_SMART_DATA = 8] = "CUSTOMER_DIRECTORY_SMART_DATA", n[n.FEEDBACK = 9] = "FEEDBACK", n[n.MESSAGING = 10] = "MESSAGING", n[n.CRM_ACTIVITY_LIST = 11] = "CRM_ACTIVITY_LIST", n[n.CRM_AUTO_PAYMENT_ASSIGNMENT = 12] = "CRM_AUTO_PAYMENT_ASSIGNMENT", n[n.CRM_INSIGHTS = 13] = "CRM_INSIGHTS", n[n.CRM_NOTES = 14] = "CRM_NOTES", n[n.CRM_SMART_GROUPS = 15] = "CRM_SMART_GROUPS", n[n.CRM_SORTING = 16] = "CRM_SORTING", n[n.CRM_LEGACY_SHOW_ALL_PAYMENTS = 17] = "CRM_LEGACY_SHOW_ALL_PAYMENTS", n[n.CRM_LEGACY_CONTACT_LOOKUP = 18] = "CRM_LEGACY_CONTACT_LOOKUP", n[n.CRM_CUSTOM_ATTRIBUTES = 20] = "CRM_CUSTOM_ATTRIBUTES", n[n.ADVANCED_INVENTORY = 19] = "ADVANCED_INVENTORY", n[n.INVENTORY_BUNDLES = 86] = "INVENTORY_BUNDLES", n[n.PREMIUM_SUPPORT = 21] = "PREMIUM_SUPPORT", n[n.RESTAURANTS = 22] = "RESTAURANTS", n[n.SPOS_DEVICE_SETTINGS = 24] = "SPOS_DEVICE_SETTINGS", n[n.RETAIL_BASIC = 25] = "RETAIL_BASIC", n[n.KDS = 27] = "KDS", n[n.PAYROLL = 28] = "PAYROLL", n[n.INVOICES_PLUS = 29] = "INVOICES_PLUS", n[n.APPOINTMENTS_FREE = 30] = "APPOINTMENTS_FREE", n[n.APPOINTMENTS_PLUS = 31] = "APPOINTMENTS_PLUS", n[n.APPOINTMENTS_PREMIUM = 32] = "APPOINTMENTS_PREMIUM", n[n.APPOINTMENTS_RESOURCE_MANAGEMENT = 33] = "APPOINTMENTS_RESOURCE_MANAGEMENT", n[n.COMMISSION_TRACKING = 34] = "COMMISSION_TRACKING", n[n.APPOINTMENTS_PROCESSING_TIME = 35] = "APPOINTMENTS_PROCESSING_TIME", n[n.APPOINTMENTS_CLASS_BOOKING = 36] = "APPOINTMENTS_CLASS_BOOKING", n[n.RESTAURANTS_MOBILE = 37] = "RESTAURANTS_MOBILE", n[n.SHIFTS_SCHEDULING_BASIC = 38] = "SHIFTS_SCHEDULING_BASIC", n[n.SHIFTS_TIME_TRACKING_BASIC = 39] = "SHIFTS_TIME_TRACKING_BASIC", n[n.SHIFTS_WAGES_BASIC = 40] = "SHIFTS_WAGES_BASIC", n[n.SHIFTS_TIPS_BASIC = 41] = "SHIFTS_TIPS_BASIC", n[n.SHIFTS_SCHEDULING_ADVANCED = 42] = "SHIFTS_SCHEDULING_ADVANCED", n[n.SHIFTS_TIME_TRACKING_ADVANCED = 43] = "SHIFTS_TIME_TRACKING_ADVANCED", n[n.SHIFTS_WAGES_ADVANCED = 44] = "SHIFTS_WAGES_ADVANCED", n[n.SHIFTS_TIPS_ADVANCED = 45] = "SHIFTS_TIPS_ADVANCED", n[n.SHIFTS_COMMISSIONS_ADVANCED = 46] = "SHIFTS_COMMISSIONS_ADVANCED", n[n.ECOM_HOSTING_FREE = 47] = "ECOM_HOSTING_FREE", n[n.ECOM_HOSTING_PROFESSIONAL = 48] = "ECOM_HOSTING_PROFESSIONAL", n[n.ECOM_HOSTING_PERFORMANCE = 49] = "ECOM_HOSTING_PERFORMANCE", n[n.ECOM_HOSTING_PREMIUM = 50] = "ECOM_HOSTING_PREMIUM", n[n.SHIFTS_SCHEDULING_BASIC_UNLIMITED = 51] = "SHIFTS_SCHEDULING_BASIC_UNLIMITED", n[n.SHIFTS_TIME_TRACKING_BASIC_UNLIMITED = 52] = "SHIFTS_TIME_TRACKING_BASIC_UNLIMITED", n[n.SHIFTS_WAGES_BASIC_UNLIMITED = 53] = "SHIFTS_WAGES_BASIC_UNLIMITED", n[n.SHIFTS_TIPS_BASIC_UNLIMITED = 54] = "SHIFTS_TIPS_BASIC_UNLIMITED", n[n.ECOM_PROFESSIONAL = 55] = "ECOM_PROFESSIONAL", n[n.ECOM_PLUS = 56] = "ECOM_PLUS", n[n.ECOM_PREMIUM = 57] = "ECOM_PREMIUM", n[n.PAYPROD_PRICING_PLAN = 58] = "PAYPROD_PRICING_PLAN", n[n.CORE = 59] = "CORE", n[n.WEB_ONLINE_ORDERING = 60] = "WEB_ONLINE_ORDERING", n[n.MOBILE_APP = 61] = "MOBILE_APP", n[n.ECOM_FREE = 62] = "ECOM_FREE", n[n.COMMS_ANNOUNCEMENTS = 63] = "COMMS_ANNOUNCEMENTS", n[n.COMMS_ANNOUNCEMENTS_ACK = 64] = "COMMS_ANNOUNCEMENTS_ACK", n[n.COMMS_MESSAGES = 65] = "COMMS_MESSAGES", n[n.COMMS_MESSAGES_TRANSLATION = 66] = "COMMS_MESSAGES_TRANSLATION", n[n.COMMS_TEAM_FILES = 67] = "COMMS_TEAM_FILES", n[n.COMMS_MEDIA_RETENTION_UNLIMITED = 68] = "COMMS_MEDIA_RETENTION_UNLIMITED", n[n.COMMS_PROFANITY_FILTER = 69] = "COMMS_PROFANITY_FILTER", n[n.COMMS_RESERVED_2 = 70] = "COMMS_RESERVED_2", n[n.COMMS_RESERVED_3 = 71] = "COMMS_RESERVED_3", n[n.COMMS_RESERVED_4 = 72] = "COMMS_RESERVED_4", n[n.COMMS_RESERVED_5 = 73] = "COMMS_RESERVED_5", n[n.COMMS_RESERVED_6 = 74] = "COMMS_RESERVED_6", n[n.MESSAGES_PLUS = 76] = "MESSAGES_PLUS", n[n.HR_TOOLKIT_BASIC = 77] = "HR_TOOLKIT_BASIC", n[n.HR_TOOLKIT_ADVANCED = 78] = "HR_TOOLKIT_ADVANCED", n[n.SPOS_AU_EXPERIMENT = 79] = "SPOS_AU_EXPERIMENT", n[n.SPOS_PAYMENTS_PAYG = 80] = "SPOS_PAYMENTS_PAYG", n[n.SPOS_PAYMENTS_S2S = 81] = "SPOS_PAYMENTS_S2S", n[n.SPOS_POS = 82] = "SPOS_POS", n[n.SPOS_PAYMENTS_PAYG_V3 = 90] = "SPOS_PAYMENTS_PAYG_V3", n[n.SPOS_POS_PAYG_V3 = 91] = "SPOS_POS_PAYG_V3", n[n.SPOS_POS_S2S_V3 = 92] = "SPOS_POS_S2S_V3", n[n.SPOS_TIERED_V1_PAYG = 98] = "SPOS_TIERED_V1_PAYG", n[n.SPOS_TIERED_V1_S2S = 99] = "SPOS_TIERED_V1_S2S", n[n.HR_MANAGER_BASIC = 83] = "HR_MANAGER_BASIC", n[n.HR_MANAGER_ADVANCED = 84] = "HR_MANAGER_ADVANCED", n[n.TEAM_MEMBERS = 85] = "TEAM_MEMBERS", n[n.FNB_KIOSK = 87] = "FNB_KIOSK", n[n.DOCUMENT_STORAGE = 88] = "DOCUMENT_STORAGE", n[n.RETAIL_PRICING_2023 = 89] = "RETAIL_PRICING_2023", n[n.RESTAURANTS_FREE = 93] = "RESTAURANTS_FREE", n[n.RESTAURANTS_PLUS = 94] = "RESTAURANTS_PLUS", n[n.RESTAURANTS_PREMIUM = 95] = "RESTAURANTS_PREMIUM", n[n.ADDITIONAL_RESTAURANTS_POS = 96] = "ADDITIONAL_RESTAURANTS_POS", n[n.APPOINTMENTS_CUSTOMER_BLOCKING = 97] = "APPOINTMENTS_CUSTOMER_BLOCKING", n[n.COMBOS = 100] = "COMBOS", n[n.NOTIFY_WHEN_READY = 101] = "NOTIFY_WHEN_READY", n[n.APPOINTMENTS_SERVICE_COST = 102] = "APPOINTMENTS_SERVICE_COST", n[n.APPOINTMENTS_CREDIT_PACKAGE = 104] = "APPOINTMENTS_CREDIT_PACKAGE", n[n.INSTANT_ACCESS = 105] = "INSTANT_ACCESS", n[n.SQUARE_ONLINE = 106] = "SQUARE_ONLINE", n[n.ITEM_SPLITS = 107] = "ITEM_SPLITS", n[n.EXPAND_FEATURE_SET = 108] = "EXPAND_FEATURE_SET", n[n.CATALOG_MGMT_CREATE_ITEMS_FROM_PO = 109] = "CATALOG_MGMT_CREATE_ITEMS_FROM_PO", n[n.CATALOG_MGMT_CREATE_BUNDLES = 110] = "CATALOG_MGMT_CREATE_BUNDLES", n[n.INVENTORY_MGMT = 111] = "INVENTORY_MGMT", n[n.INVENTORY_MGMT_STOCK_COUNTS = 112] = "INVENTORY_MGMT_STOCK_COUNTS", n[n.INVENTORY_MGMT_MANAGE_UNIT_COSTS = 113] = "INVENTORY_MGMT_MANAGE_UNIT_COSTS", n[n.INVENTORY_MGMT_PRINT_BARCODE_LABEL = 114] = "INVENTORY_MGMT_PRINT_BARCODE_LABEL", n[n.INVENTORY_MGMT_VENDOR_MGMT = 115] = "INVENTORY_MGMT_VENDOR_MGMT", n[n.INVENTORY_MGMT_PO_MGMT = 116] = "INVENTORY_MGMT_PO_MGMT", n[n.INVENTORY_MGMT_IMPORT_PO = 117] = "INVENTORY_MGMT_IMPORT_PO", n[n.INVENTORY_MGMT_PRINT_BARCODE_LABEL_FROM_PO = 118] = "INVENTORY_MGMT_PRINT_BARCODE_LABEL_FROM_PO", n[n.INVENTORY_MGMT_TRANSFER_ORDERS = 119] = "INVENTORY_MGMT_TRANSFER_ORDERS", n[n.INVENTORY_MGMT_STOCKABLE = 120] = "INVENTORY_MGMT_STOCKABLE", n[n.INVENTORY_MGMT_SELLABLE = 121] = "INVENTORY_MGMT_SELLABLE", n[n.INVENTORY_STOCK_CONVERSIONS = 122] = "INVENTORY_STOCK_CONVERSIONS", n[n.INVENTORY_HISTORY_EDITING = 123] = "INVENTORY_HISTORY_EDITING", n[n.INVENTORY_CROSS_LOC = 124] = "INVENTORY_CROSS_LOC", n[n.REPORTING_INVENTORY = 125] = "REPORTING_INVENTORY", n[n.REPORTING_COGS = 126] = "REPORTING_COGS", n[n.REPORTING_PROJECTED_PROFITS = 127] = "REPORTING_PROJECTED_PROFITS", n[n.REPORTING_INVENTORY_BY_CATEGORY = 128] = "REPORTING_INVENTORY_BY_CATEGORY", n[n.REPORTING_AGING_INVENTORY = 129] = "REPORTING_AGING_INVENTORY", n[n.REPORTING_VENDOR_SALES = 130] = "REPORTING_VENDOR_SALES", n[n.COMPLEX_TXN_EXCHANGES = 131] = "COMPLEX_TXN_EXCHANGES", n[n.COMPLEX_TXN_UNLINKED_REFUNDS = 132] = "COMPLEX_TXN_UNLINKED_REFUNDS", n[n.COMPLEX_TXN_CROSS_LOCATION_RETURNS = 133] = "COMPLEX_TXN_CROSS_LOCATION_RETURNS", n[n.CHECKOUT_ID_SCANNING = 134] = "CHECKOUT_ID_SCANNING", n[n.ORDER_MGMT_CROSS_LOCATION_FULFILLMENTS = 135] = "ORDER_MGMT_CROSS_LOCATION_FULFILLMENTS", n[n.APPOINTMENTS_MULTI_STAFF_RESERVATIONS = 136] = "APPOINTMENTS_MULTI_STAFF_RESERVATIONS", n[n.APPOINTMENTS_GOOGLE_CALENDAR_SYNC = 137] = "APPOINTMENTS_GOOGLE_CALENDAR_SYNC", n[n.APPOINTMENTS_CONFIRMATIONS = 138] = "APPOINTMENTS_CONFIRMATIONS", n[n.APPOINTMENTS_SMS_TEMPLATING = 139] = "APPOINTMENTS_SMS_TEMPLATING", n[n.APPOINTMENTS_NO_SHOW_PROTECTION = 140] = "APPOINTMENTS_NO_SHOW_PROTECTION", n[n.APPOINTMENTS_DAILY_RESERVATION_LIMIT = 141] = "APPOINTMENTS_DAILY_RESERVATION_LIMIT", n[n.APPOINTMENTS_WAITLIST = 142] = "APPOINTMENTS_WAITLIST", n[n.APPOINTMENTS_CUSTOMER_FIELDS = 143] = "APPOINTMENTS_CUSTOMER_FIELDS", n[n.APPOINTMENTS_REPORTING = 144] = "APPOINTMENTS_REPORTING", n[n.APPOINTMENTS_API_WRITES = 145] = "APPOINTMENTS_API_WRITES", n[n.FNB_SCAN_TO_PAY = 146] = "FNB_SCAN_TO_PAY", n[n.FNB_INSTANT_PAYOUTS = 147] = "FNB_INSTANT_PAYOUTS", n[n.FNB_CLOSING_PROCEDURES = 148] = "FNB_CLOSING_PROCEDURES", n[n.FNB_CLOSE_OF_DAY_REPORTS = 149] = "FNB_CLOSE_OF_DAY_REPORTS", n[n.FNB_LIVE_SALES_REPORTS = 150] = "FNB_LIVE_SALES_REPORTS", n[n.FNB_CATEGORY_ROLLUPS = 151] = "FNB_CATEGORY_ROLLUPS", n[n.FNB_MENU_REPORTS = 152] = "FNB_MENU_REPORTS", n[n.FNB_CHECKS_WEBHOOK_PAID = 153] = "FNB_CHECKS_WEBHOOK_PAID", n[n.FNB_ITEMIZATION_FEED = 154] = "FNB_ITEMIZATION_FEED", n[n.FNB_KITCHEN_PERFORMANCE_REPORTING = 155] = "FNB_KITCHEN_PERFORMANCE_REPORTING", n[n.FNB_INGREDIENT_COST_TRACKING = 156] = "FNB_INGREDIENT_COST_TRACKING", n[n.FNB_THIRD_PARTY_ORDER_MANAGEMENT = 157] = "FNB_THIRD_PARTY_ORDER_MANAGEMENT", n[n.ORDER_MGMT_NOTIFY_WHEN_READY = 158] = "ORDER_MGMT_NOTIFY_WHEN_READY", n[n.ITEM_COMBOS = 159] = "ITEM_COMBOS", n[n.FNB_FLOOR_PLAN_CUSTOMIZATION = 160] = "FNB_FLOOR_PLAN_CUSTOMIZATION", n[n.FNB_FLOOR_PLAN_DISPLAY_TIME = 161] = "FNB_FLOOR_PLAN_DISPLAY_TIME", n[n.FNB_FLOOR_PLAN_COLOR_INDICATORS = 162] = "FNB_FLOOR_PLAN_COLOR_INDICATORS", n[n.FNB_REOPEN_CLOSED_CHECKS = 163] = "FNB_REOPEN_CLOSED_CHECKS", n[n.FNB_SPLIT_CHECKS = 164] = "FNB_SPLIT_CHECKS", n[n.FNB_PRE_AUTH_BAR_TABS = 165] = "FNB_PRE_AUTH_BAR_TABS", n[n.FNB_PARTY_SIZE_AUTO_GRATUITY = 166] = "FNB_PARTY_SIZE_AUTO_GRATUITY", n[n.FNB_SECTION_SALES_REPORTS = 167] = "FNB_SECTION_SALES_REPORTS", n[n.FNB_SEAT_MANAGEMENT = 168] = "FNB_SEAT_MANAGEMENT", n[n.FNB_COURSE_MANAGEMENT = 169] = "FNB_COURSE_MANAGEMENT", n[n.FNB_RESERVATIONS = 170] = "FNB_RESERVATIONS", n[n.INVOICES_MULTIPLE_INVOICE_TEMPLATES = 171] = "INVOICES_MULTIPLE_INVOICE_TEMPLATES", n[n.INVOICES_BATCH_INVOICE_CREATION = 172] = "INVOICES_BATCH_INVOICE_CREATION", n[n.INVOICES_ADVANCED_INVOICE_FEATURES = 173] = "INVOICES_ADVANCED_INVOICE_FEATURES", n[n.INVOICES_ADVANCED_ESTIMATE_FEATURES = 174] = "INVOICES_ADVANCED_ESTIMATE_FEATURES", n[n.INVOICES_CUSTOMIZATION_SETTINGS = 175] = "INVOICES_CUSTOMIZATION_SETTINGS", n[n.INVOICES_REDUCED_PROCESSING_FEES = 202] = "INVOICES_REDUCED_PROCESSING_FEES", n[n.INVOICES_PAYMENT_SCHEDULES_UPSELL = 207] = "INVOICES_PAYMENT_SCHEDULES_UPSELL", n[n.INVOICES_REQUIRE_CONTRACT_SIGNATURE_UPSELL = 208] = "INVOICES_REQUIRE_CONTRACT_SIGNATURE_UPSELL", n[n.INVOICES_CUSTOM_FIELDS_UPSELL = 209] = "INVOICES_CUSTOM_FIELDS_UPSELL", n[n.ESTIMATES_MULTIPACKAGE_UPSELL = 210] = "ESTIMATES_MULTIPACKAGE_UPSELL", n[n.ESTIMATES_AUTOCONVERT_TO_INVOICE_UPSELL = 211] = "ESTIMATES_AUTOCONVERT_TO_INVOICE_UPSELL", n[n.CONTRACTS_DYNAMIC_BUYER_FIELDS = 176] = "CONTRACTS_DYNAMIC_BUYER_FIELDS", n[n.STAFF_UNLIMITED_CUSTOM_PERMISSION_SETS = 177] = "STAFF_UNLIMITED_CUSTOM_PERMISSION_SETS", n[n.STAFF_TEAM_MEMBER_BADGES = 178] = "STAFF_TEAM_MEMBER_BADGES", n[n.STAFF_TIMECARDS = 179] = "STAFF_TIMECARDS", n[n.STAFF_SCHEDULING = 180] = "STAFF_SCHEDULING", n[n.STAFF_MESSAGES = 181] = "STAFF_MESSAGES", n[n.STAFF_TEAM_FILES = 182] = "STAFF_TEAM_FILES", n[n.STAFF_ANNOUNCEMENTS = 183] = "STAFF_ANNOUNCEMENTS", n[n.STAFF_ADVANCED_TIP_TRACKING = 184] = "STAFF_ADVANCED_TIP_TRACKING", n[n.STAFF_COMMISSION_TRACKING = 185] = "STAFF_COMMISSION_TRACKING", n[n.STAFF_SALES_BY_TEAM_MEMBER = 186] = "STAFF_SALES_BY_TEAM_MEMBER", n[n.STAFF_LABOR_VS_SALES_REPORT = 187] = "STAFF_LABOR_VS_SALES_REPORT", n[n.STAFF_ACTIVITY_LOG_BY_TEAM_MEMBER = 188] = "STAFF_ACTIVITY_LOG_BY_TEAM_MEMBER", n[n.STAFF_TEAM_MEMBER_DOCUMENTS = 189] = "STAFF_TEAM_MEMBER_DOCUMENTS", n[n.STAFF_NEW_HIRE_ONBOARDING = 190] = "STAFF_NEW_HIRE_ONBOARDING", n[n.SQUARE_ONE = 191] = "SQUARE_ONE", n[n.INVENTORY_MGMT_PENDING_RESTOCKS = 192] = "INVENTORY_MGMT_PENDING_RESTOCKS", n[n.INVENTORY_MGMT_INVENTORY_HISTORY = 193] = "INVENTORY_MGMT_INVENTORY_HISTORY", n[n.INVENTORY_MGMT_QUICK_RECEIVE_VIA_SCAN = 194] = "INVENTORY_MGMT_QUICK_RECEIVE_VIA_SCAN", n[n.INVENTORY_MGMT_BULK_INVENTORY_RECEIVE = 195] = "INVENTORY_MGMT_BULK_INVENTORY_RECEIVE", n[n.REPORTING_INVENTORY_SELL_THROUGH = 196] = "REPORTING_INVENTORY_SELL_THROUGH", n[n.REPORTING_STOCK_OVERVIEW = 197] = "REPORTING_STOCK_OVERVIEW", n[n.FNB_RECIPES = 198] = "FNB_RECIPES", n[n.SQ1_ONLINE_FREE = 199] = "SQ1_ONLINE_FREE", n[n.SQ1_ONLINE_PLUS = 200] = "SQ1_ONLINE_PLUS", n[n.SQ1_ONLINE_PREMIUM = 201] = "SQ1_ONLINE_PREMIUM", n[n.PHONE_SUPPORT_STANDARD = 204] = "PHONE_SUPPORT_STANDARD", n[n.PHONE_SUPPORT_PRIORITY = 205] = "PHONE_SUPPORT_PRIORITY", n[n.PHONE_SUPPORT_CONCIERGE = 206] = "PHONE_SUPPORT_CONCIERGE", n[n.SQUARE_ONE_FREE = 212] = "SQUARE_ONE_FREE", n[n.SQUARE_ONE_PLUS = 213] = "SQUARE_ONE_PLUS", n[n.SQUARE_ONE_PREMIUM = 214] = "SQUARE_ONE_PREMIUM";
})(z || (z = {}));
var X;
(function(n) {
  n[n.INVALID = 0] = "INVALID", n[n.EMPLOYEE = 1] = "EMPLOYEE", n[n.RETAIL_DEVICE = 2] = "RETAIL_DEVICE", n[n.CUSTOMER = 3] = "CUSTOMER", n[n.APPOINTMENTS_EMPLOYEE = 4] = "APPOINTMENTS_EMPLOYEE", n[n.RESTAURANTS_LOCATION = 5] = "RESTAURANTS_LOCATION", n[n.RESTAURANTS_ADDITIONAL_DEVICE = 6] = "RESTAURANTS_ADDITIONAL_DEVICE", n[n.RETAIL_LOCATION = 7] = "RETAIL_LOCATION", n[n.RETAIL_ADDITIONAL_DEVICE = 8] = "RETAIL_ADDITIONAL_DEVICE", n[n.EMPLOYEE_MANAGEMENT_LOCATION = 9] = "EMPLOYEE_MANAGEMENT_LOCATION", n[n.SPOS_DEVICE_SETTINGS_DEVICE = 10] = "SPOS_DEVICE_SETTINGS_DEVICE", n[n.REACHABLE_CONTACTS = 11] = "REACHABLE_CONTACTS", n[n.LOYALTY_LOCATIONS = 12] = "LOYALTY_LOCATIONS", n[n.LOYALTY_TRANSACTIONS = 13] = "LOYALTY_TRANSACTIONS", n[n.LOYALTY_TRANSACTIONS_TIER = 14] = "LOYALTY_TRANSACTIONS_TIER", n[n.PAYROLL_EMPLOYEE = 15] = "PAYROLL_EMPLOYEE", n[n.PAYROLL_W2_EMPLOYER = 16] = "PAYROLL_W2_EMPLOYER", n[n.MARKETING_SMS_MESSAGES = 17] = "MARKETING_SMS_MESSAGES", n[n.LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_1 = 18] = "LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_1", n[n.LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_2 = 19] = "LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_2", n[n.LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_3 = 20] = "LOYALTY_LOCATIONS_ON_TRANSACTION_TIER_3", n[n.KDS_DEVICE = 21] = "KDS_DEVICE", n[n.APPOINTMENTS_LOCATIONS = 22] = "APPOINTMENTS_LOCATIONS", n[n.RESTAURANTS_MOBILE_LOCATION = 23] = "RESTAURANTS_MOBILE_LOCATION", n[n.SHIFTS_TEAM_MEMBER = 24] = "SHIFTS_TEAM_MEMBER", n[n.ECOM_SITES = 25] = "ECOM_SITES", n[n.ECOM_ACCOUNT = 26] = "ECOM_ACCOUNT", n[n.MARKETING_MMS_MESSAGES = 27] = "MARKETING_MMS_MESSAGES", n[n.COMMS_TEAM_MEMBER = 28] = "COMMS_TEAM_MEMBER", n[n.MESSAGES_LOCATION = 29] = "MESSAGES_LOCATION", n[n.HR_TOOLKIT_EMPLOYEE = 30] = "HR_TOOLKIT_EMPLOYEE", n[n.HR_MANAGER_EMPLOYEE = 31] = "HR_MANAGER_EMPLOYEE", n[n.STAFF_TEAM_MEMBER = 32] = "STAFF_TEAM_MEMBER", n[n.HR_MANAGER_TEAM_MEMBER = 33] = "HR_MANAGER_TEAM_MEMBER", n[n.PAYROLL_MAILED_TAX_FORM = 34] = "PAYROLL_MAILED_TAX_FORM", n[n.STAFF_LOCATION = 35] = "STAFF_LOCATION", n[n.FNB_KIOSK_DEVICE = 36] = "FNB_KIOSK_DEVICE", n[n.COMBOS_LOCATION = 37] = "COMBOS_LOCATION", n[n.FRANCHISE_LOCATION = 38] = "FRANCHISE_LOCATION", n[n.RESTAURANTS_MOBILE_DEVICE = 39] = "RESTAURANTS_MOBILE_DEVICE", n[n.LOYALTY_PAYG_USAGE = 40] = "LOYALTY_PAYG_USAGE", n[n.LOYALTY_PAYG_LOCATION = 41] = "LOYALTY_PAYG_LOCATION", n[n.BILLABLE_LOCATION = 42] = "BILLABLE_LOCATION";
})(X || (X = {}));
var Q;
(function(n) {
  n[n.UNKNOWN = 0] = "UNKNOWN", n[n.SQUARE = 1] = "SQUARE", n[n.APPLE = 2] = "APPLE", n[n.GOOGLE = 3] = "GOOGLE";
})(Q || (Q = {}));
var Z;
(function(n) {
  n[n.DO_NOT_USE_THIS = 0] = "DO_NOT_USE_THIS", n[n.LOWER_PROCESSING = 1] = "LOWER_PROCESSING", n[n.UNLIMITED_TIME_TRACKING = 2] = "UNLIMITED_TIME_TRACKING", n[n.LABEL_PRINTING = 3] = "LABEL_PRINTING", n[n.ADVANCED_INVENTORY_MANAGEMENT = 4] = "ADVANCED_INVENTORY_MANAGEMENT", n[n.REPORTING = 5] = "REPORTING";
})(Z || (Z = {}));
var J;
(function(n) {
  n[n.DO_NOT_USE = 0] = "DO_NOT_USE", n[n.INTERNAL = 1] = "INTERNAL", n[n.MERCHANT = 2] = "MERCHANT", n[n.PERSON = 3] = "PERSON", n[n.MERCHANT_CONTACT = 4] = "MERCHANT_CONTACT", n[n.REGISTRY_UID = 5] = "REGISTRY_UID";
})(J || (J = {}));
var w;
(function(n) {
  n[n.DO_NOT_USE = 0] = "DO_NOT_USE", n[n.SQUARE = 1] = "SQUARE", n[n.APP_MARKETPLACE = 2] = "APP_MARKETPLACE", n[n.MERCHANT = 3] = "MERCHANT";
})(w || (w = {}));
var F;
(function(n) {
  n[n.DO_NOT_USE = 0] = "DO_NOT_USE", n[n.PRE_PAY = 1] = "PRE_PAY", n[n.POST_PAY = 2] = "POST_PAY";
})(F || (F = {}));
var j;
(function(n) {
  n[n.DO_NOT_USE = 0] = "DO_NOT_USE", n[n.DAY = 1] = "DAY", n[n.MONTH = 2] = "MONTH", n[n.YEAR = 3] = "YEAR";
})(j || (j = {}));
var nn;
(function(n) {
  n[n.DO_NOT_USE = 0] = "DO_NOT_USE", n[n.AVAILABLE = 1] = "AVAILABLE", n[n.DEPRECATED = 2] = "DEPRECATED", n[n.DELETED = 3] = "DELETED";
})(nn || (nn = {}));
var en;
(function(n) {
  n[n.FIXED = 0] = "FIXED", n[n.BULK = 1] = "BULK", n[n.USAGE = 2] = "USAGE";
})(en || (en = {}));
var dn;
(function(n) {
  n[n.NONE = 0] = "NONE", n[n.BILLED = 1] = "BILLED", n[n.PAID = 2] = "PAID", n[n.FAILED = 3] = "FAILED", n[n.LAPSED = 4] = "LAPSED";
})(dn || (dn = {}));
var tn;
(function(n) {
  n[n.DO_NOT_USE = 0] = "DO_NOT_USE", n[n.CHARGED = 1] = "CHARGED", n[n.PAID = 2] = "PAID", n[n.FAILED = 3] = "FAILED", n[n.REFUNDED = 4] = "REFUNDED", n[n.DISPUTED = 5] = "DISPUTED", n[n.VOIDED = 6] = "VOIDED";
})(tn || (tn = {}));
var un;
(function(n) {
  n[n.DO_NOT_USE = 0] = "DO_NOT_USE", n[n.RULE = 1] = "RULE", n[n.UNSUPPORTED = 2] = "UNSUPPORTED";
})(un || (un = {}));
var rn;
(function(n) {
  n[n.DO_NOT_USE = 0] = "DO_NOT_USE", n[n.MIN_FEE = 1] = "MIN_FEE", n[n.MAX_FEE = 2] = "MAX_FEE";
})(rn || (rn = {}));
var an;
(function(n) {
  n[n.DO_NOT_USE = 0] = "DO_NOT_USE", n[n.BASE_FEE_ONLY = 1] = "BASE_FEE_ONLY", n[n.USAGES_ONLY = 2] = "USAGES_ONLY", n[n.BASE_FEE_AND_USAGES = 3] = "BASE_FEE_AND_USAGES";
})(an || (an = {}));
var on;
(function(n) {
  n[n.DO_NOT_USE = 0] = "DO_NOT_USE", n[n.ACTIVE = 1] = "ACTIVE", n[n.DISABLED = 2] = "DISABLED";
})(on || (on = {}));
var fn;
(function(n) {
  n[n.INPUT_TYPE_DO_NOT_USE = 0] = "INPUT_TYPE_DO_NOT_USE", n[n.SELECT = 1] = "SELECT", n[n.MULTISELECT = 2] = "MULTISELECT", n[n.TEXT = 3] = "TEXT";
})(fn || (fn = {}));
var cn;
(function(n) {
  n[n.DO_NOT_USE = 0] = "DO_NOT_USE", n[n.FEATURE_FLAG = 1] = "FEATURE_FLAG", n[n.HAS_LEGACY_SUBSCRIPTIONS = 2] = "HAS_LEGACY_SUBSCRIPTIONS", n[n.MERCHANT_CREATION_DATE = 3] = "MERCHANT_CREATION_DATE", n[n.MERCHANT_COUNTRY_CODE = 4] = "MERCHANT_COUNTRY_CODE", n[n.ELIGIBILITY_QUALIFIER = 5] = "ELIGIBILITY_QUALIFIER", n[n.EXPERIMENT_ROLLOUT = 6] = "EXPERIMENT_ROLLOUT", n[n.OPTIMIZELY_INTEGRATION_ERROR = 7] = "OPTIMIZELY_INTEGRATION_ERROR", n[n.UNSUPPORTED_ENTRY_POINT = 8] = "UNSUPPORTED_ENTRY_POINT", n[n.SUPERPOS_VERSION_TOO_LOW = 9] = "SUPERPOS_VERSION_TOO_LOW", n[n.ELIGIBILITY_STATUS_UNDETERMINED = 10] = "ELIGIBILITY_STATUS_UNDETERMINED", n[n.OVERRIDE_INELIGIBLE = 11] = "OVERRIDE_INELIGIBLE", n[n.LEGACY_CONVERSION_REQUESTED = 12] = "LEGACY_CONVERSION_REQUESTED";
})(cn || (cn = {}));
var ln;
(function(n) {
  n[n.DO_NOT_USE = 0] = "DO_NOT_USE", n[n.SUPERPOS = 1] = "SUPERPOS", n[n.GOLDEN_PATH = 2] = "GOLDEN_PATH", n[n.LEGACY_POS = 3] = "LEGACY_POS", n[n.DASHBOARD = 4] = "DASHBOARD", n[n.SQUARE_ONLINE = 5] = "SQUARE_ONLINE";
})(ln || (ln = {}));
function En() {
  return { $type: "squareup.sub2.data.Entity", tokenType: void 0, token: void 0 };
}
const c = {
  $type: "squareup.sub2.data.Entity",
  encode(n, e = u.Writer.create()) {
    return n.tokenType !== void 0 && e.uint32(8).int32(n.tokenType), n.token !== void 0 && e.uint32(18).string(n.token), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = En();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.tokenType = i.int32();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.token = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return c.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = En();
    return e.tokenType = n.tokenType ?? void 0, e.token = n.token ?? void 0, e;
  }
};
function sn() {
  return {
    $type: "squareup.sub2.data.ProductOwner",
    productOwnerEntity: void 0,
    ownerType: void 0,
    countryCode: void 0,
    sellerCode: void 0
  };
}
const O = {
  $type: "squareup.sub2.data.ProductOwner",
  encode(n, e = u.Writer.create()) {
    return n.productOwnerEntity !== void 0 && c.encode(n.productOwnerEntity, e.uint32(10).fork()).ldelim(), n.ownerType !== void 0 && e.uint32(16).int32(n.ownerType), n.countryCode !== void 0 && e.uint32(24).int32(n.countryCode), n.sellerCode !== void 0 && e.uint32(32).int32(n.sellerCode), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = sn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.productOwnerEntity = c.decode(i, i.uint32());
          continue;
        case 2:
          if (d !== 16)
            break;
          t.ownerType = i.int32();
          continue;
        case 3:
          if (d !== 24)
            break;
          t.countryCode = i.int32();
          continue;
        case 4:
          if (d !== 32)
            break;
          t.sellerCode = i.int32();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return O.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = sn();
    return e.productOwnerEntity = n.productOwnerEntity !== void 0 && n.productOwnerEntity !== null ? c.fromPartial(n.productOwnerEntity) : void 0, e.ownerType = n.ownerType ?? void 0, e.countryCode = n.countryCode ?? void 0, e.sellerCode = n.sellerCode ?? void 0, e;
  }
};
function Tn() {
  return { $type: "squareup.sub2.data.Duration", unit: void 0, count: void 0 };
}
const f = {
  $type: "squareup.sub2.data.Duration",
  encode(n, e = u.Writer.create()) {
    return n.unit !== void 0 && e.uint32(8).int32(n.unit), n.count !== void 0 && e.uint32(16).uint32(n.count), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Tn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.unit = i.int32();
          continue;
        case 2:
          if (d !== 16)
            break;
          t.count = i.uint32();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return f.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Tn();
    return e.unit = n.unit ?? void 0, e.count = n.count ?? void 0, e;
  }
};
function _n() {
  return {
    $type: "squareup.sub2.data.Plan",
    productOwner: void 0,
    productToken: void 0,
    name: void 0,
    availabilityStatus: void 0,
    pricing: void 0,
    renewalCycle: void 0,
    freeTrialDuration: void 0,
    taxClass: void 0,
    feature: [],
    noObligationFreeTrialExpiredDuration: void 0,
    token: void 0
  };
}
const P = {
  $type: "squareup.sub2.data.Plan",
  encode(n, e = u.Writer.create()) {
    n.productOwner !== void 0 && O.encode(n.productOwner, e.uint32(10).fork()).ldelim(), n.productToken !== void 0 && e.uint32(18).string(n.productToken), n.name !== void 0 && e.uint32(26).string(n.name), n.availabilityStatus !== void 0 && e.uint32(32).int32(n.availabilityStatus), n.pricing !== void 0 && l.encode(n.pricing, e.uint32(42).fork()).ldelim(), n.renewalCycle !== void 0 && f.encode(n.renewalCycle, e.uint32(50).fork()).ldelim(), n.freeTrialDuration !== void 0 && f.encode(n.freeTrialDuration, e.uint32(58).fork()).ldelim(), n.taxClass !== void 0 && e.uint32(66).string(n.taxClass), e.uint32(74).fork();
    for (const i of n.feature)
      e.int32(i);
    return e.ldelim(), n.noObligationFreeTrialExpiredDuration !== void 0 && f.encode(n.noObligationFreeTrialExpiredDuration, e.uint32(82).fork()).ldelim(), n.token !== void 0 && e.uint32(90).string(n.token), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = _n();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.productOwner = O.decode(i, i.uint32());
          continue;
        case 2:
          if (d !== 18)
            break;
          t.productToken = i.string();
          continue;
        case 3:
          if (d !== 26)
            break;
          t.name = i.string();
          continue;
        case 4:
          if (d !== 32)
            break;
          t.availabilityStatus = i.int32();
          continue;
        case 5:
          if (d !== 42)
            break;
          t.pricing = l.decode(i, i.uint32());
          continue;
        case 6:
          if (d !== 50)
            break;
          t.renewalCycle = f.decode(i, i.uint32());
          continue;
        case 7:
          if (d !== 58)
            break;
          t.freeTrialDuration = f.decode(i, i.uint32());
          continue;
        case 8:
          if (d !== 66)
            break;
          t.taxClass = i.string();
          continue;
        case 9:
          if (d === 72) {
            t.feature.push(i.int32());
            continue;
          }
          if (d === 74) {
            const E = i.uint32() + i.pos;
            for (; i.pos < E; )
              t.feature.push(i.int32());
            continue;
          }
          break;
        case 10:
          if (d !== 82)
            break;
          t.noObligationFreeTrialExpiredDuration = f.decode(i, i.uint32());
          continue;
        case 11:
          if (d !== 90)
            break;
          t.token = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return P.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = _n();
    return e.productOwner = n.productOwner !== void 0 && n.productOwner !== null ? O.fromPartial(n.productOwner) : void 0, e.productToken = n.productToken ?? void 0, e.name = n.name ?? void 0, e.availabilityStatus = n.availabilityStatus ?? void 0, e.pricing = n.pricing !== void 0 && n.pricing !== null ? l.fromPartial(n.pricing) : void 0, e.renewalCycle = n.renewalCycle !== void 0 && n.renewalCycle !== null ? f.fromPartial(n.renewalCycle) : void 0, e.freeTrialDuration = n.freeTrialDuration !== void 0 && n.freeTrialDuration !== null ? f.fromPartial(n.freeTrialDuration) : void 0, e.taxClass = n.taxClass ?? void 0, e.feature = ((i = n.feature) == null ? void 0 : i.map((r) => r)) || [], e.noObligationFreeTrialExpiredDuration = n.noObligationFreeTrialExpiredDuration !== void 0 && n.noObligationFreeTrialExpiredDuration !== null ? f.fromPartial(n.noObligationFreeTrialExpiredDuration) : void 0, e.token = n.token ?? void 0, e;
  }
};
function An() {
  return {
    $type: "squareup.sub2.data.PlanComponent",
    feature: void 0,
    plan: void 0,
    cancelWarning: void 0,
    maintainDescription: void 0
  };
}
const oe = {
  $type: "squareup.sub2.data.PlanComponent",
  encode(n, e = u.Writer.create()) {
    return n.feature !== void 0 && e.uint32(8).int32(n.feature), n.plan !== void 0 && P.encode(n.plan, e.uint32(18).fork()).ldelim(), n.cancelWarning !== void 0 && e.uint32(26).string(n.cancelWarning), n.maintainDescription !== void 0 && e.uint32(34).string(n.maintainDescription), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = An();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.feature = i.int32();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.plan = P.decode(i, i.uint32());
          continue;
        case 3:
          if (d !== 26)
            break;
          t.cancelWarning = i.string();
          continue;
        case 4:
          if (d !== 34)
            break;
          t.maintainDescription = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return oe.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = An();
    return e.feature = n.feature ?? void 0, e.plan = n.plan !== void 0 && n.plan !== null ? P.fromPartial(n.plan) : void 0, e.cancelWarning = n.cancelWarning ?? void 0, e.maintainDescription = n.maintainDescription ?? void 0, e;
  }
};
function Nn() {
  return { $type: "squareup.sub2.data.SaasMoney", currencyCode: void 0, amount: void 0 };
}
const R = {
  $type: "squareup.sub2.data.SaasMoney",
  encode(n, e = u.Writer.create()) {
    const i = re();
    try {
      return n.currencyCode !== void 0 && e.uint32(8).int32(n.currencyCode), n.amount !== void 0 && e.uint32(16).int64(n.amount), e;
    } finally {
      i();
    }
  },
  decode(n, e) {
    const i = re();
    try {
      const r = n instanceof u.Reader ? n : u.Reader.create(n);
      let t = e === void 0 ? r.len : r.pos + e;
      const d = Nn();
      for (; r.pos < t; ) {
        const E = r.uint32();
        switch (E >>> 3) {
          case 1:
            if (E !== 8)
              break;
            d.currencyCode = r.int32();
            continue;
          case 2:
            if (E !== 16)
              break;
            d.amount = pe(r.int64());
            continue;
        }
        if ((E & 7) === 4 || E === 0)
          break;
        r.skipType(E & 7);
      }
      return d;
    } finally {
      i();
    }
  },
  create(n) {
    return R.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Nn();
    return e.currencyCode = n.currencyCode ?? void 0, e.amount = n.amount ?? void 0, e;
  }
};
function Sn() {
  return { $type: "squareup.sub2.data.FixedPricing", cost: void 0 };
}
const I = {
  $type: "squareup.sub2.data.FixedPricing",
  encode(n, e = u.Writer.create()) {
    return n.cost !== void 0 && o.encode(n.cost, e.uint32(10).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Sn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.cost = o.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return I.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Sn();
    return e.cost = n.cost !== void 0 && n.cost !== null ? o.fromPartial(n.cost) : void 0, e;
  }
};
function On() {
  return {
    $type: "squareup.sub2.data.TieredPricing",
    unitType: void 0,
    pricingTier: [],
    currentTier: void 0,
    calculation: void 0
  };
}
const p = {
  $type: "squareup.sub2.data.TieredPricing",
  encode(n, e = u.Writer.create()) {
    n.unitType !== void 0 && e.uint32(8).int32(n.unitType);
    for (const i of n.pricingTier)
      s.encode(i, e.uint32(18).fork()).ldelim();
    return n.currentTier !== void 0 && s.encode(n.currentTier, e.uint32(26).fork()).ldelim(), n.calculation !== void 0 && e.uint32(32).int32(n.calculation), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = On();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.unitType = i.int32();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.pricingTier.push(s.decode(i, i.uint32()));
          continue;
        case 3:
          if (d !== 26)
            break;
          t.currentTier = s.decode(i, i.uint32());
          continue;
        case 4:
          if (d !== 32)
            break;
          t.calculation = i.int32();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return p.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = On();
    return e.unitType = n.unitType ?? void 0, e.pricingTier = ((i = n.pricingTier) == null ? void 0 : i.map((r) => s.fromPartial(r))) || [], e.currentTier = n.currentTier !== void 0 && n.currentTier !== null ? s.fromPartial(n.currentTier) : void 0, e.calculation = n.calculation ?? void 0, e;
  }
};
function Pn() {
  return {
    $type: "squareup.sub2.data.TieredPricing.Tier",
    name: void 0,
    minUsageCount: void 0,
    maxUsageCount: void 0,
    cost: void 0,
    baseCost: void 0
  };
}
const s = {
  $type: "squareup.sub2.data.TieredPricing.Tier",
  encode(n, e = u.Writer.create()) {
    return n.name !== void 0 && e.uint32(10).string(n.name), n.minUsageCount !== void 0 && e.uint32(24).uint32(n.minUsageCount), n.maxUsageCount !== void 0 && e.uint32(32).uint32(n.maxUsageCount), n.cost !== void 0 && o.encode(n.cost, e.uint32(42).fork()).ldelim(), n.baseCost !== void 0 && o.encode(n.baseCost, e.uint32(50).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Pn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.name = i.string();
          continue;
        case 3:
          if (d !== 24)
            break;
          t.minUsageCount = i.uint32();
          continue;
        case 4:
          if (d !== 32)
            break;
          t.maxUsageCount = i.uint32();
          continue;
        case 5:
          if (d !== 42)
            break;
          t.cost = o.decode(i, i.uint32());
          continue;
        case 6:
          if (d !== 50)
            break;
          t.baseCost = o.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return s.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Pn();
    return e.name = n.name ?? void 0, e.minUsageCount = n.minUsageCount ?? void 0, e.maxUsageCount = n.maxUsageCount ?? void 0, e.cost = n.cost !== void 0 && n.cost !== null ? o.fromPartial(n.cost) : void 0, e.baseCost = n.baseCost !== void 0 && n.baseCost !== null ? o.fromPartial(n.baseCost) : void 0, e;
  }
};
function Rn() {
  return {
    $type: "squareup.sub2.data.BucketPricing",
    cost: void 0,
    unitType: void 0,
    bucketSize: void 0,
    minUnits: void 0,
    baseCost: void 0
  };
}
const C = {
  $type: "squareup.sub2.data.BucketPricing",
  encode(n, e = u.Writer.create()) {
    return n.cost !== void 0 && o.encode(n.cost, e.uint32(10).fork()).ldelim(), n.unitType !== void 0 && e.uint32(16).int32(n.unitType), n.bucketSize !== void 0 && e.uint32(24).uint32(n.bucketSize), n.minUnits !== void 0 && e.uint32(32).uint32(n.minUnits), n.baseCost !== void 0 && o.encode(n.baseCost, e.uint32(42).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Rn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.cost = o.decode(i, i.uint32());
          continue;
        case 2:
          if (d !== 16)
            break;
          t.unitType = i.int32();
          continue;
        case 3:
          if (d !== 24)
            break;
          t.bucketSize = i.uint32();
          continue;
        case 4:
          if (d !== 32)
            break;
          t.minUnits = i.uint32();
          continue;
        case 5:
          if (d !== 42)
            break;
          t.baseCost = o.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return C.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Rn();
    return e.cost = n.cost !== void 0 && n.cost !== null ? o.fromPartial(n.cost) : void 0, e.unitType = n.unitType ?? void 0, e.bucketSize = n.bucketSize ?? void 0, e.minUnits = n.minUnits ?? void 0, e.baseCost = n.baseCost !== void 0 && n.baseCost !== null ? o.fromPartial(n.baseCost) : void 0, e;
  }
};
function In() {
  return {
    $type: "squareup.sub2.data.UsageBucket",
    cost: void 0,
    unitType: void 0,
    size: void 0,
    minUnits: void 0,
    label: void 0,
    freeUnitCount: void 0,
    fractionalCost: void 0
  };
}
const k = {
  $type: "squareup.sub2.data.UsageBucket",
  encode(n, e = u.Writer.create()) {
    return n.cost !== void 0 && o.encode(n.cost, e.uint32(10).fork()).ldelim(), n.unitType !== void 0 && e.uint32(16).int32(n.unitType), n.size !== void 0 && e.uint32(24).uint32(n.size), n.minUnits !== void 0 && e.uint32(32).uint32(n.minUnits), n.label !== void 0 && e.uint32(42).string(n.label), n.freeUnitCount !== void 0 && e.uint32(48).uint32(n.freeUnitCount), n.fractionalCost !== void 0 && R.encode(n.fractionalCost, e.uint32(58).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = In();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.cost = o.decode(i, i.uint32());
          continue;
        case 2:
          if (d !== 16)
            break;
          t.unitType = i.int32();
          continue;
        case 3:
          if (d !== 24)
            break;
          t.size = i.uint32();
          continue;
        case 4:
          if (d !== 32)
            break;
          t.minUnits = i.uint32();
          continue;
        case 5:
          if (d !== 42)
            break;
          t.label = i.string();
          continue;
        case 6:
          if (d !== 48)
            break;
          t.freeUnitCount = i.uint32();
          continue;
        case 7:
          if (d !== 58)
            break;
          t.fractionalCost = R.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return k.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = In();
    return e.cost = n.cost !== void 0 && n.cost !== null ? o.fromPartial(n.cost) : void 0, e.unitType = n.unitType ?? void 0, e.size = n.size ?? void 0, e.minUnits = n.minUnits ?? void 0, e.label = n.label ?? void 0, e.freeUnitCount = n.freeUnitCount ?? void 0, e.fractionalCost = n.fractionalCost !== void 0 && n.fractionalCost !== null ? R.fromPartial(n.fractionalCost) : void 0, e;
  }
};
function pn() {
  return { $type: "squareup.sub2.data.MultiBucketPricing", buckets: [], baseCost: void 0 };
}
const M = {
  $type: "squareup.sub2.data.MultiBucketPricing",
  encode(n, e = u.Writer.create()) {
    for (const i of n.buckets)
      k.encode(i, e.uint32(10).fork()).ldelim();
    return n.baseCost !== void 0 && o.encode(n.baseCost, e.uint32(18).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = pn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.buckets.push(k.decode(i, i.uint32()));
          continue;
        case 2:
          if (d !== 18)
            break;
          t.baseCost = o.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return M.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = pn();
    return e.buckets = ((i = n.buckets) == null ? void 0 : i.map((r) => k.fromPartial(r))) || [], e.baseCost = n.baseCost !== void 0 && n.baseCost !== null ? o.fromPartial(n.baseCost) : void 0, e;
  }
};
function Cn() {
  return {
    $type: "squareup.sub2.data.RetailPricing",
    retailDeviceCost: void 0,
    excessEmployeeCost: void 0,
    excessCustomerBucketCost: void 0
  };
}
const D = {
  $type: "squareup.sub2.data.RetailPricing",
  encode(n, e = u.Writer.create()) {
    return n.retailDeviceCost !== void 0 && o.encode(n.retailDeviceCost, e.uint32(10).fork()).ldelim(), n.excessEmployeeCost !== void 0 && o.encode(n.excessEmployeeCost, e.uint32(18).fork()).ldelim(), n.excessCustomerBucketCost !== void 0 && o.encode(n.excessCustomerBucketCost, e.uint32(26).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Cn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.retailDeviceCost = o.decode(i, i.uint32());
          continue;
        case 2:
          if (d !== 18)
            break;
          t.excessEmployeeCost = o.decode(i, i.uint32());
          continue;
        case 3:
          if (d !== 26)
            break;
          t.excessCustomerBucketCost = o.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return D.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Cn();
    return e.retailDeviceCost = n.retailDeviceCost !== void 0 && n.retailDeviceCost !== null ? o.fromPartial(n.retailDeviceCost) : void 0, e.excessEmployeeCost = n.excessEmployeeCost !== void 0 && n.excessEmployeeCost !== null ? o.fromPartial(n.excessEmployeeCost) : void 0, e.excessCustomerBucketCost = n.excessCustomerBucketCost !== void 0 && n.excessCustomerBucketCost !== null ? o.fromPartial(n.excessCustomerBucketCost) : void 0, e;
  }
};
function kn() {
  return {
    $type: "squareup.sub2.data.Pricing",
    fixedPricing: void 0,
    bucketPricing: void 0,
    retailPricing: void 0,
    tieredPricing: void 0,
    multiBucketPricing: void 0,
    label: void 0,
    startAt: void 0,
    expireAt: void 0,
    customPricing: void 0
  };
}
const l = {
  $type: "squareup.sub2.data.Pricing",
  encode(n, e = u.Writer.create()) {
    return n.fixedPricing !== void 0 && I.encode(n.fixedPricing, e.uint32(10).fork()).ldelim(), n.bucketPricing !== void 0 && C.encode(n.bucketPricing, e.uint32(18).fork()).ldelim(), n.retailPricing !== void 0 && D.encode(n.retailPricing, e.uint32(26).fork()).ldelim(), n.tieredPricing !== void 0 && p.encode(n.tieredPricing, e.uint32(34).fork()).ldelim(), n.multiBucketPricing !== void 0 && M.encode(n.multiBucketPricing, e.uint32(50).fork()).ldelim(), n.label !== void 0 && e.uint32(42).string(n.label), n.startAt !== void 0 && a.encode(n.startAt, e.uint32(58).fork()).ldelim(), n.expireAt !== void 0 && a.encode(n.expireAt, e.uint32(66).fork()).ldelim(), n.customPricing !== void 0 && e.uint32(72).bool(n.customPricing), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = kn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.fixedPricing = I.decode(i, i.uint32());
          continue;
        case 2:
          if (d !== 18)
            break;
          t.bucketPricing = C.decode(i, i.uint32());
          continue;
        case 3:
          if (d !== 26)
            break;
          t.retailPricing = D.decode(i, i.uint32());
          continue;
        case 4:
          if (d !== 34)
            break;
          t.tieredPricing = p.decode(i, i.uint32());
          continue;
        case 6:
          if (d !== 50)
            break;
          t.multiBucketPricing = M.decode(i, i.uint32());
          continue;
        case 5:
          if (d !== 42)
            break;
          t.label = i.string();
          continue;
        case 7:
          if (d !== 58)
            break;
          t.startAt = a.decode(i, i.uint32());
          continue;
        case 8:
          if (d !== 66)
            break;
          t.expireAt = a.decode(i, i.uint32());
          continue;
        case 9:
          if (d !== 72)
            break;
          t.customPricing = i.bool();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return l.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = kn();
    return e.fixedPricing = n.fixedPricing !== void 0 && n.fixedPricing !== null ? I.fromPartial(n.fixedPricing) : void 0, e.bucketPricing = n.bucketPricing !== void 0 && n.bucketPricing !== null ? C.fromPartial(n.bucketPricing) : void 0, e.retailPricing = n.retailPricing !== void 0 && n.retailPricing !== null ? D.fromPartial(n.retailPricing) : void 0, e.tieredPricing = n.tieredPricing !== void 0 && n.tieredPricing !== null ? p.fromPartial(n.tieredPricing) : void 0, e.multiBucketPricing = n.multiBucketPricing !== void 0 && n.multiBucketPricing !== null ? M.fromPartial(n.multiBucketPricing) : void 0, e.label = n.label ?? void 0, e.startAt = n.startAt !== void 0 && n.startAt !== null ? a.fromPartial(n.startAt) : void 0, e.expireAt = n.expireAt !== void 0 && n.expireAt !== null ? a.fromPartial(n.expireAt) : void 0, e.customPricing = n.customPricing ?? void 0, e;
  }
};
function Mn() {
  return { $type: "squareup.sub2.data.SingleUnitUsage", unitType: void 0, count: void 0 };
}
const L = {
  $type: "squareup.sub2.data.SingleUnitUsage",
  encode(n, e = u.Writer.create()) {
    return n.unitType !== void 0 && e.uint32(8).int32(n.unitType), n.count !== void 0 && e.uint32(16).uint32(n.count), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Mn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.unitType = i.int32();
          continue;
        case 2:
          if (d !== 16)
            break;
          t.count = i.uint32();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return L.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Mn();
    return e.unitType = n.unitType ?? void 0, e.count = n.count ?? void 0, e;
  }
};
function Dn() {
  return {
    $type: "squareup.sub2.data.PlanChange",
    effectiveAt: void 0,
    planToken: void 0,
    planName: void 0,
    previousSubscriptionStatus: void 0,
    previousPlanToken: void 0,
    previousPlanBillingCycle: void 0
  };
}
const T = {
  $type: "squareup.sub2.data.PlanChange",
  encode(n, e = u.Writer.create()) {
    return n.effectiveAt !== void 0 && a.encode(n.effectiveAt, e.uint32(10).fork()).ldelim(), n.planToken !== void 0 && e.uint32(18).string(n.planToken), n.planName !== void 0 && e.uint32(26).string(n.planName), n.previousSubscriptionStatus !== void 0 && e.uint32(32).int32(n.previousSubscriptionStatus), n.previousPlanToken !== void 0 && e.uint32(42).string(n.previousPlanToken), n.previousPlanBillingCycle !== void 0 && e.uint32(50).string(n.previousPlanBillingCycle), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Dn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.effectiveAt = a.decode(i, i.uint32());
          continue;
        case 2:
          if (d !== 18)
            break;
          t.planToken = i.string();
          continue;
        case 3:
          if (d !== 26)
            break;
          t.planName = i.string();
          continue;
        case 4:
          if (d !== 32)
            break;
          t.previousSubscriptionStatus = i.int32();
          continue;
        case 5:
          if (d !== 42)
            break;
          t.previousPlanToken = i.string();
          continue;
        case 6:
          if (d !== 50)
            break;
          t.previousPlanBillingCycle = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return T.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Dn();
    return e.effectiveAt = n.effectiveAt !== void 0 && n.effectiveAt !== null ? a.fromPartial(n.effectiveAt) : void 0, e.planToken = n.planToken ?? void 0, e.planName = n.planName ?? void 0, e.previousSubscriptionStatus = n.previousSubscriptionStatus ?? void 0, e.previousPlanToken = n.previousPlanToken ?? void 0, e.previousPlanBillingCycle = n.previousPlanBillingCycle ?? void 0, e;
  }
};
function Ln() {
  return { $type: "squareup.sub2.data.Usage", unitUsages: [] };
}
const A = {
  $type: "squareup.sub2.data.Usage",
  encode(n, e = u.Writer.create()) {
    for (const i of n.unitUsages)
      L.encode(i, e.uint32(18).fork()).ldelim();
    return e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Ln();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 2:
          if (d !== 18)
            break;
          t.unitUsages.push(L.decode(i, i.uint32()));
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return A.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = Ln();
    return e.unitUsages = ((i = n.unitUsages) == null ? void 0 : i.map((r) => L.fromPartial(r))) || [], e;
  }
};
function mn() {
  return {
    $type: "squareup.sub2.data.Subscription",
    token: void 0,
    subscriberEntity: void 0,
    planToken: void 0,
    productOwnerEntity: void 0,
    status: void 0,
    billingStatus: void 0,
    startAt: void 0,
    endAt: void 0,
    freeTrialEndDate: void 0,
    renewalAt: void 0,
    planName: void 0,
    freeTrialEndAt: void 0,
    nextFeeAmount: void 0,
    currentUsage: void 0,
    renewalCycle: void 0,
    pricing: void 0,
    nextFeeDate: void 0,
    currentCost: void 0,
    features: [],
    paused: void 0,
    pauseAt: void 0,
    resumeAt: void 0,
    pendingDowngrade: void 0,
    lastPlanChange: void 0,
    free: void 0,
    planGroupToken: void 0,
    planBillingCycle: void 0,
    delinquentAt: void 0,
    canPause: void 0,
    bundleToken: void 0,
    managedBy: void 0,
    pendingPricing: void 0,
    version: void 0
  };
}
const fe = {
  $type: "squareup.sub2.data.Subscription",
  encode(n, e = u.Writer.create()) {
    n.token !== void 0 && e.uint32(10).string(n.token), n.subscriberEntity !== void 0 && c.encode(n.subscriberEntity, e.uint32(18).fork()).ldelim(), n.planToken !== void 0 && e.uint32(26).string(n.planToken), n.productOwnerEntity !== void 0 && c.encode(n.productOwnerEntity, e.uint32(34).fork()).ldelim(), n.status !== void 0 && e.uint32(40).int32(n.status), n.billingStatus !== void 0 && e.uint32(48).int32(n.billingStatus), n.startAt !== void 0 && a.encode(n.startAt, e.uint32(58).fork()).ldelim(), n.endAt !== void 0 && a.encode(n.endAt, e.uint32(66).fork()).ldelim(), n.freeTrialEndDate !== void 0 && g.encode(n.freeTrialEndDate, e.uint32(74).fork()).ldelim(), n.renewalAt !== void 0 && a.encode(n.renewalAt, e.uint32(82).fork()).ldelim(), n.planName !== void 0 && e.uint32(90).string(n.planName), n.freeTrialEndAt !== void 0 && a.encode(n.freeTrialEndAt, e.uint32(98).fork()).ldelim(), n.nextFeeAmount !== void 0 && o.encode(n.nextFeeAmount, e.uint32(106).fork()).ldelim(), n.currentUsage !== void 0 && A.encode(n.currentUsage, e.uint32(114).fork()).ldelim(), n.renewalCycle !== void 0 && f.encode(n.renewalCycle, e.uint32(122).fork()).ldelim(), n.pricing !== void 0 && l.encode(n.pricing, e.uint32(130).fork()).ldelim(), n.nextFeeDate !== void 0 && a.encode(n.nextFeeDate, e.uint32(138).fork()).ldelim(), n.currentCost !== void 0 && o.encode(n.currentCost, e.uint32(146).fork()).ldelim(), e.uint32(154).fork();
    for (const i of n.features)
      e.int32(i);
    return e.ldelim(), n.paused !== void 0 && e.uint32(160).bool(n.paused), n.pauseAt !== void 0 && a.encode(n.pauseAt, e.uint32(178).fork()).ldelim(), n.resumeAt !== void 0 && a.encode(n.resumeAt, e.uint32(170).fork()).ldelim(), n.pendingDowngrade !== void 0 && T.encode(n.pendingDowngrade, e.uint32(186).fork()).ldelim(), n.lastPlanChange !== void 0 && T.encode(n.lastPlanChange, e.uint32(194).fork()).ldelim(), n.free !== void 0 && e.uint32(200).bool(n.free), n.planGroupToken !== void 0 && e.uint32(210).string(n.planGroupToken), n.planBillingCycle !== void 0 && e.uint32(224).int32(n.planBillingCycle), n.delinquentAt !== void 0 && a.encode(n.delinquentAt, e.uint32(234).fork()).ldelim(), n.canPause !== void 0 && e.uint32(240).bool(n.canPause), n.bundleToken !== void 0 && e.uint32(250).string(n.bundleToken), n.managedBy !== void 0 && e.uint32(256).int32(n.managedBy), n.pendingPricing !== void 0 && l.encode(n.pendingPricing, e.uint32(266).fork()).ldelim(), n.version !== void 0 && e.uint32(272).int32(n.version), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = mn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.token = i.string();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.subscriberEntity = c.decode(i, i.uint32());
          continue;
        case 3:
          if (d !== 26)
            break;
          t.planToken = i.string();
          continue;
        case 4:
          if (d !== 34)
            break;
          t.productOwnerEntity = c.decode(i, i.uint32());
          continue;
        case 5:
          if (d !== 40)
            break;
          t.status = i.int32();
          continue;
        case 6:
          if (d !== 48)
            break;
          t.billingStatus = i.int32();
          continue;
        case 7:
          if (d !== 58)
            break;
          t.startAt = a.decode(i, i.uint32());
          continue;
        case 8:
          if (d !== 66)
            break;
          t.endAt = a.decode(i, i.uint32());
          continue;
        case 9:
          if (d !== 74)
            break;
          t.freeTrialEndDate = g.decode(i, i.uint32());
          continue;
        case 10:
          if (d !== 82)
            break;
          t.renewalAt = a.decode(i, i.uint32());
          continue;
        case 11:
          if (d !== 90)
            break;
          t.planName = i.string();
          continue;
        case 12:
          if (d !== 98)
            break;
          t.freeTrialEndAt = a.decode(i, i.uint32());
          continue;
        case 13:
          if (d !== 106)
            break;
          t.nextFeeAmount = o.decode(i, i.uint32());
          continue;
        case 14:
          if (d !== 114)
            break;
          t.currentUsage = A.decode(i, i.uint32());
          continue;
        case 15:
          if (d !== 122)
            break;
          t.renewalCycle = f.decode(i, i.uint32());
          continue;
        case 16:
          if (d !== 130)
            break;
          t.pricing = l.decode(i, i.uint32());
          continue;
        case 17:
          if (d !== 138)
            break;
          t.nextFeeDate = a.decode(i, i.uint32());
          continue;
        case 18:
          if (d !== 146)
            break;
          t.currentCost = o.decode(i, i.uint32());
          continue;
        case 19:
          if (d === 152) {
            t.features.push(i.int32());
            continue;
          }
          if (d === 154) {
            const E = i.uint32() + i.pos;
            for (; i.pos < E; )
              t.features.push(i.int32());
            continue;
          }
          break;
        case 20:
          if (d !== 160)
            break;
          t.paused = i.bool();
          continue;
        case 22:
          if (d !== 178)
            break;
          t.pauseAt = a.decode(i, i.uint32());
          continue;
        case 21:
          if (d !== 170)
            break;
          t.resumeAt = a.decode(i, i.uint32());
          continue;
        case 23:
          if (d !== 186)
            break;
          t.pendingDowngrade = T.decode(i, i.uint32());
          continue;
        case 24:
          if (d !== 194)
            break;
          t.lastPlanChange = T.decode(i, i.uint32());
          continue;
        case 25:
          if (d !== 200)
            break;
          t.free = i.bool();
          continue;
        case 26:
          if (d !== 210)
            break;
          t.planGroupToken = i.string();
          continue;
        case 28:
          if (d !== 224)
            break;
          t.planBillingCycle = i.int32();
          continue;
        case 29:
          if (d !== 234)
            break;
          t.delinquentAt = a.decode(i, i.uint32());
          continue;
        case 30:
          if (d !== 240)
            break;
          t.canPause = i.bool();
          continue;
        case 31:
          if (d !== 250)
            break;
          t.bundleToken = i.string();
          continue;
        case 32:
          if (d !== 256)
            break;
          t.managedBy = i.int32();
          continue;
        case 33:
          if (d !== 266)
            break;
          t.pendingPricing = l.decode(i, i.uint32());
          continue;
        case 34:
          if (d !== 272)
            break;
          t.version = i.int32();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return fe.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = mn();
    return e.token = n.token ?? void 0, e.subscriberEntity = n.subscriberEntity !== void 0 && n.subscriberEntity !== null ? c.fromPartial(n.subscriberEntity) : void 0, e.planToken = n.planToken ?? void 0, e.productOwnerEntity = n.productOwnerEntity !== void 0 && n.productOwnerEntity !== null ? c.fromPartial(n.productOwnerEntity) : void 0, e.status = n.status ?? void 0, e.billingStatus = n.billingStatus ?? void 0, e.startAt = n.startAt !== void 0 && n.startAt !== null ? a.fromPartial(n.startAt) : void 0, e.endAt = n.endAt !== void 0 && n.endAt !== null ? a.fromPartial(n.endAt) : void 0, e.freeTrialEndDate = n.freeTrialEndDate !== void 0 && n.freeTrialEndDate !== null ? g.fromPartial(n.freeTrialEndDate) : void 0, e.renewalAt = n.renewalAt !== void 0 && n.renewalAt !== null ? a.fromPartial(n.renewalAt) : void 0, e.planName = n.planName ?? void 0, e.freeTrialEndAt = n.freeTrialEndAt !== void 0 && n.freeTrialEndAt !== null ? a.fromPartial(n.freeTrialEndAt) : void 0, e.nextFeeAmount = n.nextFeeAmount !== void 0 && n.nextFeeAmount !== null ? o.fromPartial(n.nextFeeAmount) : void 0, e.currentUsage = n.currentUsage !== void 0 && n.currentUsage !== null ? A.fromPartial(n.currentUsage) : void 0, e.renewalCycle = n.renewalCycle !== void 0 && n.renewalCycle !== null ? f.fromPartial(n.renewalCycle) : void 0, e.pricing = n.pricing !== void 0 && n.pricing !== null ? l.fromPartial(n.pricing) : void 0, e.nextFeeDate = n.nextFeeDate !== void 0 && n.nextFeeDate !== null ? a.fromPartial(n.nextFeeDate) : void 0, e.currentCost = n.currentCost !== void 0 && n.currentCost !== null ? o.fromPartial(n.currentCost) : void 0, e.features = ((i = n.features) == null ? void 0 : i.map((r) => r)) || [], e.paused = n.paused ?? void 0, e.pauseAt = n.pauseAt !== void 0 && n.pauseAt !== null ? a.fromPartial(n.pauseAt) : void 0, e.resumeAt = n.resumeAt !== void 0 && n.resumeAt !== null ? a.fromPartial(n.resumeAt) : void 0, e.pendingDowngrade = n.pendingDowngrade !== void 0 && n.pendingDowngrade !== null ? T.fromPartial(n.pendingDowngrade) : void 0, e.lastPlanChange = n.lastPlanChange !== void 0 && n.lastPlanChange !== null ? T.fromPartial(n.lastPlanChange) : void 0, e.free = n.free ?? void 0, e.planGroupToken = n.planGroupToken ?? void 0, e.planBillingCycle = n.planBillingCycle ?? void 0, e.delinquentAt = n.delinquentAt !== void 0 && n.delinquentAt !== null ? a.fromPartial(n.delinquentAt) : void 0, e.canPause = n.canPause ?? void 0, e.bundleToken = n.bundleToken ?? void 0, e.managedBy = n.managedBy ?? void 0, e.pendingPricing = n.pendingPricing !== void 0 && n.pendingPricing !== null ? l.fromPartial(n.pendingPricing) : void 0, e.version = n.version ?? void 0, e;
  }
};
function Bn() {
  return { $type: "squareup.sub2.data.DisplayedFeature", featureName: void 0, featureDescription: void 0 };
}
const ce = {
  $type: "squareup.sub2.data.DisplayedFeature",
  encode(n, e = u.Writer.create()) {
    return n.featureName !== void 0 && e.uint32(8).int32(n.featureName), n.featureDescription !== void 0 && e.uint32(18).string(n.featureDescription), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Bn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.featureName = i.int32();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.featureDescription = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return ce.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Bn();
    return e.featureName = n.featureName ?? void 0, e.featureDescription = n.featureDescription ?? void 0, e;
  }
};
function Gn() {
  return {
    $type: "squareup.sub2.data.SubscriptionKey",
    subscriber: void 0,
    planToken: void 0,
    planBillingCycle: void 0,
    productOwner: void 0
  };
}
const le = {
  $type: "squareup.sub2.data.SubscriptionKey",
  encode(n, e = u.Writer.create()) {
    return n.subscriber !== void 0 && c.encode(n.subscriber, e.uint32(10).fork()).ldelim(), n.planToken !== void 0 && e.uint32(18).string(n.planToken), n.planBillingCycle !== void 0 && e.uint32(32).int32(n.planBillingCycle), n.productOwner !== void 0 && c.encode(n.productOwner, e.uint32(26).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Gn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.subscriber = c.decode(i, i.uint32());
          continue;
        case 2:
          if (d !== 18)
            break;
          t.planToken = i.string();
          continue;
        case 4:
          if (d !== 32)
            break;
          t.planBillingCycle = i.int32();
          continue;
        case 3:
          if (d !== 26)
            break;
          t.productOwner = c.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return le.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Gn();
    return e.subscriber = n.subscriber !== void 0 && n.subscriber !== null ? c.fromPartial(n.subscriber) : void 0, e.planToken = n.planToken ?? void 0, e.planBillingCycle = n.planBillingCycle ?? void 0, e.productOwner = n.productOwner !== void 0 && n.productOwner !== null ? c.fromPartial(n.productOwner) : void 0, e;
  }
};
function bn() {
  return { $type: "squareup.sub2.data.UnavailableReason", code: void 0, detail: void 0 };
}
const m = {
  $type: "squareup.sub2.data.UnavailableReason",
  encode(n, e = u.Writer.create()) {
    return n.code !== void 0 && e.uint32(8).int32(n.code), n.detail !== void 0 && e.uint32(18).string(n.detail), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = bn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.code = i.int32();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.detail = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return m.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = bn();
    return e.code = n.code ?? void 0, e.detail = n.detail ?? void 0, e;
  }
};
function Yn() {
  return {
    $type: "squareup.sub2.data.LocalizedHeadlinePlanPricing",
    localizedAmount: void 0,
    localizedRecurrencyText: void 0
  };
}
const B = {
  $type: "squareup.sub2.data.LocalizedHeadlinePlanPricing",
  encode(n, e = u.Writer.create()) {
    return n.localizedAmount !== void 0 && e.uint32(10).string(n.localizedAmount), n.localizedRecurrencyText !== void 0 && e.uint32(18).string(n.localizedRecurrencyText), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Yn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.localizedAmount = i.string();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.localizedRecurrencyText = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return B.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Yn();
    return e.localizedAmount = n.localizedAmount ?? void 0, e.localizedRecurrencyText = n.localizedRecurrencyText ?? void 0, e;
  }
};
function Vn() {
  return {
    $type: "squareup.sub2.data.ExternalPlan",
    token: void 0,
    name: void 0,
    description: void 0,
    free: void 0,
    available: void 0,
    unavailableReasons: [],
    pricing: void 0,
    numFreeTrialDays: void 0,
    renewalCycle: void 0,
    estimatedCost: void 0,
    usageData: void 0,
    billingCycle: void 0,
    country: void 0,
    localizedHeadlinePlanPricing: void 0,
    headlineFeeRates: []
  };
}
const N = {
  $type: "squareup.sub2.data.ExternalPlan",
  encode(n, e = u.Writer.create()) {
    n.token !== void 0 && e.uint32(10).string(n.token), n.name !== void 0 && e.uint32(18).string(n.name), n.description !== void 0 && e.uint32(26).string(n.description), n.free !== void 0 && e.uint32(32).bool(n.free), n.available !== void 0 && e.uint32(40).bool(n.available);
    for (const i of n.unavailableReasons)
      m.encode(i, e.uint32(50).fork()).ldelim();
    n.pricing !== void 0 && l.encode(n.pricing, e.uint32(58).fork()).ldelim(), n.numFreeTrialDays !== void 0 && e.uint32(64).uint32(n.numFreeTrialDays), n.renewalCycle !== void 0 && f.encode(n.renewalCycle, e.uint32(74).fork()).ldelim(), n.estimatedCost !== void 0 && o.encode(n.estimatedCost, e.uint32(82).fork()).ldelim(), n.usageData !== void 0 && A.encode(n.usageData, e.uint32(90).fork()).ldelim(), n.billingCycle !== void 0 && e.uint32(96).int32(n.billingCycle), n.country !== void 0 && e.uint32(104).int32(n.country), n.localizedHeadlinePlanPricing !== void 0 && B.encode(n.localizedHeadlinePlanPricing, e.uint32(114).fork()).ldelim();
    for (const i of n.headlineFeeRates)
      Y.encode(i, e.uint32(122).fork()).ldelim();
    return e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Vn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.token = i.string();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.name = i.string();
          continue;
        case 3:
          if (d !== 26)
            break;
          t.description = i.string();
          continue;
        case 4:
          if (d !== 32)
            break;
          t.free = i.bool();
          continue;
        case 5:
          if (d !== 40)
            break;
          t.available = i.bool();
          continue;
        case 6:
          if (d !== 50)
            break;
          t.unavailableReasons.push(m.decode(i, i.uint32()));
          continue;
        case 7:
          if (d !== 58)
            break;
          t.pricing = l.decode(i, i.uint32());
          continue;
        case 8:
          if (d !== 64)
            break;
          t.numFreeTrialDays = i.uint32();
          continue;
        case 9:
          if (d !== 74)
            break;
          t.renewalCycle = f.decode(i, i.uint32());
          continue;
        case 10:
          if (d !== 82)
            break;
          t.estimatedCost = o.decode(i, i.uint32());
          continue;
        case 11:
          if (d !== 90)
            break;
          t.usageData = A.decode(i, i.uint32());
          continue;
        case 12:
          if (d !== 96)
            break;
          t.billingCycle = i.int32();
          continue;
        case 13:
          if (d !== 104)
            break;
          t.country = i.int32();
          continue;
        case 14:
          if (d !== 114)
            break;
          t.localizedHeadlinePlanPricing = B.decode(i, i.uint32());
          continue;
        case 15:
          if (d !== 122)
            break;
          t.headlineFeeRates.push(Y.decode(i, i.uint32()));
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return N.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i, r;
    const e = Vn();
    return e.token = n.token ?? void 0, e.name = n.name ?? void 0, e.description = n.description ?? void 0, e.free = n.free ?? void 0, e.available = n.available ?? void 0, e.unavailableReasons = ((i = n.unavailableReasons) == null ? void 0 : i.map((t) => m.fromPartial(t))) || [], e.pricing = n.pricing !== void 0 && n.pricing !== null ? l.fromPartial(n.pricing) : void 0, e.numFreeTrialDays = n.numFreeTrialDays ?? void 0, e.renewalCycle = n.renewalCycle !== void 0 && n.renewalCycle !== null ? f.fromPartial(n.renewalCycle) : void 0, e.estimatedCost = n.estimatedCost !== void 0 && n.estimatedCost !== null ? o.fromPartial(n.estimatedCost) : void 0, e.usageData = n.usageData !== void 0 && n.usageData !== null ? A.fromPartial(n.usageData) : void 0, e.billingCycle = n.billingCycle ?? void 0, e.country = n.country ?? void 0, e.localizedHeadlinePlanPricing = n.localizedHeadlinePlanPricing !== void 0 && n.localizedHeadlinePlanPricing !== null ? B.fromPartial(n.localizedHeadlinePlanPricing) : void 0, e.headlineFeeRates = ((r = n.headlineFeeRates) == null ? void 0 : r.map((t) => Y.fromPartial(t))) || [], e;
  }
};
function Un() {
  return {
    $type: "squareup.sub2.data.BaseRate",
    variableBasisPoints: void 0,
    fixedCents: void 0,
    constraints: []
  };
}
const G = {
  $type: "squareup.sub2.data.BaseRate",
  encode(n, e = u.Writer.create()) {
    n.variableBasisPoints !== void 0 && e.uint32(8).uint32(n.variableBasisPoints), n.fixedCents !== void 0 && e.uint32(16).uint32(n.fixedCents);
    for (const i of n.constraints)
      b.encode(i, e.uint32(26).fork()).ldelim();
    return e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Un();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.variableBasisPoints = i.uint32();
          continue;
        case 2:
          if (d !== 16)
            break;
          t.fixedCents = i.uint32();
          continue;
        case 3:
          if (d !== 26)
            break;
          t.constraints.push(b.decode(i, i.uint32()));
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return G.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = Un();
    return e.variableBasisPoints = n.variableBasisPoints ?? void 0, e.fixedCents = n.fixedCents ?? void 0, e.constraints = ((i = n.constraints) == null ? void 0 : i.map((r) => b.fromPartial(r))) || [], e;
  }
};
function yn() {
  return { $type: "squareup.sub2.data.BaseRate.FeeRateConstraint", type: void 0, amountBaseUnit: void 0 };
}
const b = {
  $type: "squareup.sub2.data.BaseRate.FeeRateConstraint",
  encode(n, e = u.Writer.create()) {
    return n.type !== void 0 && e.uint32(8).int32(n.type), n.amountBaseUnit !== void 0 && e.uint32(16).uint32(n.amountBaseUnit), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = yn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.type = i.int32();
          continue;
        case 2:
          if (d !== 16)
            break;
          t.amountBaseUnit = i.uint32();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return b.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = yn();
    return e.type = n.type ?? void 0, e.amountBaseUnit = n.amountBaseUnit ?? void 0, e;
  }
};
function Hn() {
  return {
    $type: "squareup.sub2.data.HeadlineFeeRate",
    headlineRateName: void 0,
    localizedHeadlineRateName: void 0,
    currencyCode: void 0,
    baseRate: void 0,
    localizedBaseRateDisplay: void 0
  };
}
const Y = {
  $type: "squareup.sub2.data.HeadlineFeeRate",
  encode(n, e = u.Writer.create()) {
    return n.headlineRateName !== void 0 && e.uint32(8).int32(n.headlineRateName), n.localizedHeadlineRateName !== void 0 && e.uint32(18).string(n.localizedHeadlineRateName), n.currencyCode !== void 0 && e.uint32(24).int32(n.currencyCode), n.baseRate !== void 0 && G.encode(n.baseRate, e.uint32(34).fork()).ldelim(), n.localizedBaseRateDisplay !== void 0 && e.uint32(42).string(n.localizedBaseRateDisplay), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Hn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.headlineRateName = i.int32();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.localizedHeadlineRateName = i.string();
          continue;
        case 3:
          if (d !== 24)
            break;
          t.currencyCode = i.int32();
          continue;
        case 4:
          if (d !== 34)
            break;
          t.baseRate = G.decode(i, i.uint32());
          continue;
        case 5:
          if (d !== 42)
            break;
          t.localizedBaseRateDisplay = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return Y.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Hn();
    return e.headlineRateName = n.headlineRateName ?? void 0, e.localizedHeadlineRateName = n.localizedHeadlineRateName ?? void 0, e.currencyCode = n.currencyCode ?? void 0, e.baseRate = n.baseRate !== void 0 && n.baseRate !== null ? G.fromPartial(n.baseRate) : void 0, e.localizedBaseRateDisplay = n.localizedBaseRateDisplay ?? void 0, e;
  }
};
function xn() {
  return {
    $type: "squareup.sub2.data.PlanGroup",
    token: void 0,
    plans: [],
    compareUrl: void 0,
    tiers: [],
    immediateDowngrades: []
  };
}
const Ee = {
  $type: "squareup.sub2.data.PlanGroup",
  encode(n, e = u.Writer.create()) {
    n.token !== void 0 && e.uint32(10).string(n.token);
    for (const i of n.plans)
      N.encode(i, e.uint32(18).fork()).ldelim();
    n.compareUrl !== void 0 && e.uint32(26).string(n.compareUrl);
    for (const i of n.tiers)
      $.encode(i, e.uint32(34).fork()).ldelim();
    for (const i of n.immediateDowngrades)
      W.encode(i, e.uint32(42).fork()).ldelim();
    return e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = xn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.token = i.string();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.plans.push(N.decode(i, i.uint32()));
          continue;
        case 3:
          if (d !== 26)
            break;
          t.compareUrl = i.string();
          continue;
        case 4:
          if (d !== 34)
            break;
          t.tiers.push($.decode(i, i.uint32()));
          continue;
        case 5:
          if (d !== 42)
            break;
          t.immediateDowngrades.push(W.decode(i, i.uint32()));
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return Ee.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i, r, t;
    const e = xn();
    return e.token = n.token ?? void 0, e.plans = ((i = n.plans) == null ? void 0 : i.map((d) => N.fromPartial(d))) || [], e.compareUrl = n.compareUrl ?? void 0, e.tiers = ((r = n.tiers) == null ? void 0 : r.map((d) => $.fromPartial(d))) || [], e.immediateDowngrades = ((t = n.immediateDowngrades) == null ? void 0 : t.map((d) => W.fromPartial(d))) || [], e;
  }
};
function vn() {
  return {
    $type: "squareup.sub2.data.BundlePlanUsagePercentDiscount",
    unitType: void 0,
    percentDiscount: void 0
  };
}
const V = {
  $type: "squareup.sub2.data.BundlePlanUsagePercentDiscount",
  encode(n, e = u.Writer.create()) {
    return n.unitType !== void 0 && e.uint32(8).int32(n.unitType), n.percentDiscount !== void 0 && e.uint32(16).uint32(n.percentDiscount), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = vn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.unitType = i.int32();
          continue;
        case 2:
          if (d !== 16)
            break;
          t.percentDiscount = i.uint32();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return V.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = vn();
    return e.unitType = n.unitType ?? void 0, e.percentDiscount = n.percentDiscount ?? void 0, e;
  }
};
function Kn() {
  return { $type: "squareup.sub2.data.BundlePlanUsageFixedDiscount", unitType: void 0, fixedDiscount: void 0 };
}
const U = {
  $type: "squareup.sub2.data.BundlePlanUsageFixedDiscount",
  encode(n, e = u.Writer.create()) {
    return n.unitType !== void 0 && e.uint32(8).int32(n.unitType), n.fixedDiscount !== void 0 && o.encode(n.fixedDiscount, e.uint32(18).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Kn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.unitType = i.int32();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.fixedDiscount = o.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return U.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Kn();
    return e.unitType = n.unitType ?? void 0, e.fixedDiscount = n.fixedDiscount !== void 0 && n.fixedDiscount !== null ? o.fromPartial(n.fixedDiscount) : void 0, e;
  }
};
function $n() {
  return {
    $type: "squareup.sub2.data.PercentDiscountBundlePriceAdjustment",
    discountedComponents: void 0,
    percent: void 0
  };
}
const y = {
  $type: "squareup.sub2.data.PercentDiscountBundlePriceAdjustment",
  encode(n, e = u.Writer.create()) {
    return n.discountedComponents !== void 0 && e.uint32(8).int32(n.discountedComponents), n.percent !== void 0 && e.uint32(16).uint32(n.percent), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = $n();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.discountedComponents = i.int32();
          continue;
        case 2:
          if (d !== 16)
            break;
          t.percent = i.uint32();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return y.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = $n();
    return e.discountedComponents = n.discountedComponents ?? void 0, e.percent = n.percent ?? void 0, e;
  }
};
function Wn() {
  return {
    $type: "squareup.sub2.data.PlanPercentDiscountBundlePriceAdjustment",
    baseFeeDiscount: void 0,
    usageDiscounts: [],
    planToken: void 0
  };
}
const H = {
  $type: "squareup.sub2.data.PlanPercentDiscountBundlePriceAdjustment",
  encode(n, e = u.Writer.create()) {
    n.baseFeeDiscount !== void 0 && e.uint32(8).uint32(n.baseFeeDiscount);
    for (const i of n.usageDiscounts)
      V.encode(i, e.uint32(18).fork()).ldelim();
    return n.planToken !== void 0 && e.uint32(26).string(n.planToken), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Wn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.baseFeeDiscount = i.uint32();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.usageDiscounts.push(V.decode(i, i.uint32()));
          continue;
        case 3:
          if (d !== 26)
            break;
          t.planToken = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return H.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = Wn();
    return e.baseFeeDiscount = n.baseFeeDiscount ?? void 0, e.usageDiscounts = ((i = n.usageDiscounts) == null ? void 0 : i.map((r) => V.fromPartial(r))) || [], e.planToken = n.planToken ?? void 0, e;
  }
};
function qn() {
  return {
    $type: "squareup.sub2.data.PlanFixedDiscountBundlePriceAdjustment",
    baseFeeDiscount: void 0,
    usageDiscounts: [],
    planToken: void 0
  };
}
const x = {
  $type: "squareup.sub2.data.PlanFixedDiscountBundlePriceAdjustment",
  encode(n, e = u.Writer.create()) {
    n.baseFeeDiscount !== void 0 && o.encode(n.baseFeeDiscount, e.uint32(10).fork()).ldelim();
    for (const i of n.usageDiscounts)
      U.encode(i, e.uint32(18).fork()).ldelim();
    return n.planToken !== void 0 && e.uint32(26).string(n.planToken), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = qn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.baseFeeDiscount = o.decode(i, i.uint32());
          continue;
        case 2:
          if (d !== 18)
            break;
          t.usageDiscounts.push(U.decode(i, i.uint32()));
          continue;
        case 3:
          if (d !== 26)
            break;
          t.planToken = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return x.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = qn();
    return e.baseFeeDiscount = n.baseFeeDiscount !== void 0 && n.baseFeeDiscount !== null ? o.fromPartial(n.baseFeeDiscount) : void 0, e.usageDiscounts = ((i = n.usageDiscounts) == null ? void 0 : i.map((r) => U.fromPartial(r))) || [], e.planToken = n.planToken ?? void 0, e;
  }
};
function hn() {
  return {
    $type: "squareup.sub2.data.BundlePriceAdjustment",
    percentDiscountPriceAdjustment: void 0,
    planPercentDiscountPriceAdjustment: void 0,
    planFixedDiscountPriceAdjustment: void 0,
    label: void 0
  };
}
const v = {
  $type: "squareup.sub2.data.BundlePriceAdjustment",
  encode(n, e = u.Writer.create()) {
    return n.percentDiscountPriceAdjustment !== void 0 && y.encode(n.percentDiscountPriceAdjustment, e.uint32(10).fork()).ldelim(), n.planPercentDiscountPriceAdjustment !== void 0 && H.encode(n.planPercentDiscountPriceAdjustment, e.uint32(26).fork()).ldelim(), n.planFixedDiscountPriceAdjustment !== void 0 && x.encode(n.planFixedDiscountPriceAdjustment, e.uint32(34).fork()).ldelim(), n.label !== void 0 && e.uint32(18).string(n.label), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = hn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.percentDiscountPriceAdjustment = y.decode(i, i.uint32());
          continue;
        case 3:
          if (d !== 26)
            break;
          t.planPercentDiscountPriceAdjustment = H.decode(i, i.uint32());
          continue;
        case 4:
          if (d !== 34)
            break;
          t.planFixedDiscountPriceAdjustment = x.decode(i, i.uint32());
          continue;
        case 2:
          if (d !== 18)
            break;
          t.label = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return v.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = hn();
    return e.percentDiscountPriceAdjustment = n.percentDiscountPriceAdjustment !== void 0 && n.percentDiscountPriceAdjustment !== null ? y.fromPartial(n.percentDiscountPriceAdjustment) : void 0, e.planPercentDiscountPriceAdjustment = n.planPercentDiscountPriceAdjustment !== void 0 && n.planPercentDiscountPriceAdjustment !== null ? H.fromPartial(n.planPercentDiscountPriceAdjustment) : void 0, e.planFixedDiscountPriceAdjustment = n.planFixedDiscountPriceAdjustment !== void 0 && n.planFixedDiscountPriceAdjustment !== null ? x.fromPartial(n.planFixedDiscountPriceAdjustment) : void 0, e.label = n.label ?? void 0, e;
  }
};
function gn() {
  return { $type: "squareup.sub2.data.BundlePricing", priceAdjustments: [] };
}
const S = {
  $type: "squareup.sub2.data.BundlePricing",
  encode(n, e = u.Writer.create()) {
    for (const i of n.priceAdjustments)
      v.encode(i, e.uint32(10).fork()).ldelim();
    return e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = gn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.priceAdjustments.push(v.decode(i, i.uint32()));
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return S.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = gn();
    return e.priceAdjustments = ((i = n.priceAdjustments) == null ? void 0 : i.map((r) => v.fromPartial(r))) || [], e;
  }
};
function zn() {
  return {
    $type: "squareup.sub2.data.Bundle",
    token: void 0,
    subscriberEntity: void 0,
    bundleOfferingToken: void 0,
    bundleOfferingVersion: void 0,
    bundleOfferingName: void 0,
    status: void 0,
    startAt: void 0,
    endAt: void 0,
    pricing: [],
    expireAt: void 0
  };
}
const se = {
  $type: "squareup.sub2.data.Bundle",
  encode(n, e = u.Writer.create()) {
    n.token !== void 0 && e.uint32(10).string(n.token), n.subscriberEntity !== void 0 && c.encode(n.subscriberEntity, e.uint32(18).fork()).ldelim(), n.bundleOfferingToken !== void 0 && e.uint32(26).string(n.bundleOfferingToken), n.bundleOfferingVersion !== void 0 && e.uint32(32).uint32(n.bundleOfferingVersion), n.bundleOfferingName !== void 0 && e.uint32(42).string(n.bundleOfferingName), n.status !== void 0 && e.uint32(50).string(n.status), n.startAt !== void 0 && a.encode(n.startAt, e.uint32(58).fork()).ldelim(), n.endAt !== void 0 && a.encode(n.endAt, e.uint32(66).fork()).ldelim();
    for (const i of n.pricing)
      S.encode(i, e.uint32(74).fork()).ldelim();
    return n.expireAt !== void 0 && a.encode(n.expireAt, e.uint32(82).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = zn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.token = i.string();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.subscriberEntity = c.decode(i, i.uint32());
          continue;
        case 3:
          if (d !== 26)
            break;
          t.bundleOfferingToken = i.string();
          continue;
        case 4:
          if (d !== 32)
            break;
          t.bundleOfferingVersion = i.uint32();
          continue;
        case 5:
          if (d !== 42)
            break;
          t.bundleOfferingName = i.string();
          continue;
        case 6:
          if (d !== 50)
            break;
          t.status = i.string();
          continue;
        case 7:
          if (d !== 58)
            break;
          t.startAt = a.decode(i, i.uint32());
          continue;
        case 8:
          if (d !== 66)
            break;
          t.endAt = a.decode(i, i.uint32());
          continue;
        case 9:
          if (d !== 74)
            break;
          t.pricing.push(S.decode(i, i.uint32()));
          continue;
        case 10:
          if (d !== 82)
            break;
          t.expireAt = a.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return se.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = zn();
    return e.token = n.token ?? void 0, e.subscriberEntity = n.subscriberEntity !== void 0 && n.subscriberEntity !== null ? c.fromPartial(n.subscriberEntity) : void 0, e.bundleOfferingToken = n.bundleOfferingToken ?? void 0, e.bundleOfferingVersion = n.bundleOfferingVersion ?? void 0, e.bundleOfferingName = n.bundleOfferingName ?? void 0, e.status = n.status ?? void 0, e.startAt = n.startAt !== void 0 && n.startAt !== null ? a.fromPartial(n.startAt) : void 0, e.endAt = n.endAt !== void 0 && n.endAt !== null ? a.fromPartial(n.endAt) : void 0, e.pricing = ((i = n.pricing) == null ? void 0 : i.map((r) => S.fromPartial(r))) || [], e.expireAt = n.expireAt !== void 0 && n.expireAt !== null ? a.fromPartial(n.expireAt) : void 0, e;
  }
};
function Xn() {
  return {
    $type: "squareup.sub2.data.BundleOffering",
    name: void 0,
    availabilityStatus: void 0,
    plans: [],
    freeTrialDuration: void 0,
    token: void 0,
    version: void 0,
    pricing: [],
    offeringDuration: void 0
  };
}
const Te = {
  $type: "squareup.sub2.data.BundleOffering",
  encode(n, e = u.Writer.create()) {
    n.name !== void 0 && e.uint32(10).string(n.name), n.availabilityStatus !== void 0 && e.uint32(16).int32(n.availabilityStatus);
    for (const i of n.plans)
      N.encode(i, e.uint32(26).fork()).ldelim();
    n.freeTrialDuration !== void 0 && f.encode(n.freeTrialDuration, e.uint32(34).fork()).ldelim(), n.token !== void 0 && e.uint32(42).string(n.token), n.version !== void 0 && e.uint32(48).uint32(n.version);
    for (const i of n.pricing)
      S.encode(i, e.uint32(58).fork()).ldelim();
    return n.offeringDuration !== void 0 && f.encode(n.offeringDuration, e.uint32(66).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Xn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.name = i.string();
          continue;
        case 2:
          if (d !== 16)
            break;
          t.availabilityStatus = i.int32();
          continue;
        case 3:
          if (d !== 26)
            break;
          t.plans.push(N.decode(i, i.uint32()));
          continue;
        case 4:
          if (d !== 34)
            break;
          t.freeTrialDuration = f.decode(i, i.uint32());
          continue;
        case 5:
          if (d !== 42)
            break;
          t.token = i.string();
          continue;
        case 6:
          if (d !== 48)
            break;
          t.version = i.uint32();
          continue;
        case 7:
          if (d !== 58)
            break;
          t.pricing.push(S.decode(i, i.uint32()));
          continue;
        case 8:
          if (d !== 66)
            break;
          t.offeringDuration = f.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return Te.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i, r;
    const e = Xn();
    return e.name = n.name ?? void 0, e.availabilityStatus = n.availabilityStatus ?? void 0, e.plans = ((i = n.plans) == null ? void 0 : i.map((t) => N.fromPartial(t))) || [], e.freeTrialDuration = n.freeTrialDuration !== void 0 && n.freeTrialDuration !== null ? f.fromPartial(n.freeTrialDuration) : void 0, e.token = n.token ?? void 0, e.version = n.version ?? void 0, e.pricing = ((r = n.pricing) == null ? void 0 : r.map((t) => S.fromPartial(t))) || [], e.offeringDuration = n.offeringDuration !== void 0 && n.offeringDuration !== null ? f.fromPartial(n.offeringDuration) : void 0, e;
  }
};
function Qn() {
  return {
    $type: "squareup.sub2.data.FeedbackOption",
    token: void 0,
    inputType: void 0,
    secondaryOptions: [],
    label: void 0
  };
}
const _ = {
  $type: "squareup.sub2.data.FeedbackOption",
  encode(n, e = u.Writer.create()) {
    n.token !== void 0 && e.uint32(10).string(n.token), n.inputType !== void 0 && e.uint32(16).int32(n.inputType);
    for (const i of n.secondaryOptions)
      _.encode(i, e.uint32(26).fork()).ldelim();
    return n.label !== void 0 && e.uint32(34).string(n.label), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Qn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.token = i.string();
          continue;
        case 2:
          if (d !== 16)
            break;
          t.inputType = i.int32();
          continue;
        case 3:
          if (d !== 26)
            break;
          t.secondaryOptions.push(_.decode(i, i.uint32()));
          continue;
        case 4:
          if (d !== 34)
            break;
          t.label = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return _.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = Qn();
    return e.token = n.token ?? void 0, e.inputType = n.inputType ?? void 0, e.secondaryOptions = ((i = n.secondaryOptions) == null ? void 0 : i.map((r) => _.fromPartial(r))) || [], e.label = n.label ?? void 0, e;
  }
};
function Zn() {
  return { $type: "squareup.sub2.data.FeedbackOptionList", token: void 0, feedbackOptions: [] };
}
const _e = {
  $type: "squareup.sub2.data.FeedbackOptionList",
  encode(n, e = u.Writer.create()) {
    n.token !== void 0 && e.uint32(10).string(n.token);
    for (const i of n.feedbackOptions)
      _.encode(i, e.uint32(18).fork()).ldelim();
    return e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Zn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.token = i.string();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.feedbackOptions.push(_.decode(i, i.uint32()));
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return _e.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = Zn();
    return e.token = n.token ?? void 0, e.feedbackOptions = ((i = n.feedbackOptions) == null ? void 0 : i.map((r) => _.fromPartial(r))) || [], e;
  }
};
function Jn() {
  return { $type: "squareup.sub2.data.Feedback", feedbackOptionToken: void 0, text: void 0 };
}
const Ae = {
  $type: "squareup.sub2.data.Feedback",
  encode(n, e = u.Writer.create()) {
    return n.feedbackOptionToken !== void 0 && e.uint32(10).string(n.feedbackOptionToken), n.text !== void 0 && e.uint32(18).string(n.text), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Jn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.feedbackOptionToken = i.string();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.text = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return Ae.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Jn();
    return e.feedbackOptionToken = n.feedbackOptionToken ?? void 0, e.text = n.text ?? void 0, e;
  }
};
function wn() {
  return { $type: "squareup.sub2.data.SuperPOSMode", engine: void 0, modeTemplateName: void 0 };
}
const K = {
  $type: "squareup.sub2.data.SuperPOSMode",
  encode(n, e = u.Writer.create()) {
    return n.engine !== void 0 && e.uint32(8).int32(n.engine), n.modeTemplateName !== void 0 && e.uint32(18).string(n.modeTemplateName), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = wn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.engine = i.int32();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.modeTemplateName = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return K.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = wn();
    return e.engine = n.engine ?? void 0, e.modeTemplateName = n.modeTemplateName ?? void 0, e;
  }
};
function Fn() {
  return { $type: "squareup.sub2.data.ActivationSource", nonPosSource: void 0, superPosMode: void 0 };
}
const Ne = {
  $type: "squareup.sub2.data.ActivationSource",
  encode(n, e = u.Writer.create()) {
    return n.nonPosSource !== void 0 && e.uint32(10).string(n.nonPosSource), n.superPosMode !== void 0 && K.encode(n.superPosMode, e.uint32(18).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = Fn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.nonPosSource = i.string();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.superPosMode = K.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return Ne.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = Fn();
    return e.nonPosSource = n.nonPosSource ?? void 0, e.superPosMode = n.superPosMode !== void 0 && n.superPosMode !== null ? K.fromPartial(n.superPosMode) : void 0, e;
  }
};
function jn() {
  return {
    $type: "squareup.sub2.data.SquareOneEligibility",
    eligible: void 0,
    eligiblePlanGroupToken: void 0,
    ineligibilityReason: void 0,
    flagName: void 0
  };
}
const Se = {
  $type: "squareup.sub2.data.SquareOneEligibility",
  encode(n, e = u.Writer.create()) {
    return n.eligible !== void 0 && e.uint32(8).bool(n.eligible), n.eligiblePlanGroupToken !== void 0 && e.uint32(18).string(n.eligiblePlanGroupToken), n.ineligibilityReason !== void 0 && e.uint32(24).int32(n.ineligibilityReason), n.flagName !== void 0 && e.uint32(34).string(n.flagName), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = jn();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.eligible = i.bool();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.eligiblePlanGroupToken = i.string();
          continue;
        case 3:
          if (d !== 24)
            break;
          t.ineligibilityReason = i.int32();
          continue;
        case 4:
          if (d !== 34)
            break;
          t.flagName = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return Se.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = jn();
    return e.eligible = n.eligible ?? void 0, e.eligiblePlanGroupToken = n.eligiblePlanGroupToken ?? void 0, e.ineligibilityReason = n.ineligibilityReason ?? void 0, e.flagName = n.flagName ?? void 0, e;
  }
};
function ne() {
  return {
    $type: "squareup.sub2.data.EligibilityQualifier",
    onboardingEntryPoint: void 0,
    superposVersion: void 0
  };
}
const Oe = {
  $type: "squareup.sub2.data.EligibilityQualifier",
  encode(n, e = u.Writer.create()) {
    return n.onboardingEntryPoint !== void 0 && e.uint32(8).int32(n.onboardingEntryPoint), n.superposVersion !== void 0 && h.encode(n.superposVersion, e.uint32(18).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = ne();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 8)
            break;
          t.onboardingEntryPoint = i.int32();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.superposVersion = h.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return Oe.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ne();
    return e.onboardingEntryPoint = n.onboardingEntryPoint ?? void 0, e.superposVersion = n.superposVersion !== void 0 && n.superposVersion !== null ? h.fromPartial(n.superposVersion) : void 0, e;
  }
};
function ee() {
  return { $type: "squareup.sub2.data.ActiveTrial", planToken: void 0, planTierToken: void 0, endAt: void 0 };
}
const Pe = {
  $type: "squareup.sub2.data.ActiveTrial",
  encode(n, e = u.Writer.create()) {
    return n.planToken !== void 0 && e.uint32(10).string(n.planToken), n.planTierToken !== void 0 && e.uint32(18).string(n.planTierToken), n.endAt !== void 0 && a.encode(n.endAt, e.uint32(26).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = ee();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.planToken = i.string();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.planTierToken = i.string();
          continue;
        case 3:
          if (d !== 26)
            break;
          t.endAt = a.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return Pe.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ee();
    return e.planToken = n.planToken ?? void 0, e.planTierToken = n.planTierToken ?? void 0, e.endAt = n.endAt !== void 0 && n.endAt !== null ? a.fromPartial(n.endAt) : void 0, e;
  }
};
function ie() {
  return {
    $type: "squareup.sub2.data.AvailableTrial",
    planToken: void 0,
    planTierToken: void 0,
    days: void 0
  };
}
const Re = {
  $type: "squareup.sub2.data.AvailableTrial",
  encode(n, e = u.Writer.create()) {
    return n.planToken !== void 0 && e.uint32(10).string(n.planToken), n.planTierToken !== void 0 && e.uint32(18).string(n.planTierToken), n.days !== void 0 && e.uint32(24).uint32(n.days), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = ie();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.planToken = i.string();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.planTierToken = i.string();
          continue;
        case 3:
          if (d !== 24)
            break;
          t.days = i.uint32();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return Re.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ie();
    return e.planToken = n.planToken ?? void 0, e.planTierToken = n.planTierToken ?? void 0, e.days = n.days ?? void 0, e;
  }
};
function de() {
  return {
    $type: "squareup.sub2.data.ConsumedTrial",
    planToken: void 0,
    planTierToken: void 0,
    endAt: void 0
  };
}
const Ie = {
  $type: "squareup.sub2.data.ConsumedTrial",
  encode(n, e = u.Writer.create()) {
    return n.planToken !== void 0 && e.uint32(10).string(n.planToken), n.planTierToken !== void 0 && e.uint32(18).string(n.planTierToken), n.endAt !== void 0 && a.encode(n.endAt, e.uint32(26).fork()).ldelim(), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = de();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.planToken = i.string();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.planTierToken = i.string();
          continue;
        case 3:
          if (d !== 26)
            break;
          t.endAt = a.decode(i, i.uint32());
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return Ie.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = de();
    return e.planToken = n.planToken ?? void 0, e.planTierToken = n.planTierToken ?? void 0, e.endAt = n.endAt !== void 0 && n.endAt !== null ? a.fromPartial(n.endAt) : void 0, e;
  }
};
function te() {
  return {
    $type: "squareup.sub2.data.PlanGroupTier",
    token: void 0,
    planTokens: [],
    numFreeTrialDays: void 0,
    localizedTierName: void 0
  };
}
const $ = {
  $type: "squareup.sub2.data.PlanGroupTier",
  encode(n, e = u.Writer.create()) {
    n.token !== void 0 && e.uint32(10).string(n.token);
    for (const i of n.planTokens)
      e.uint32(18).string(i);
    return n.numFreeTrialDays !== void 0 && e.uint32(24).uint32(n.numFreeTrialDays), n.localizedTierName !== void 0 && e.uint32(34).string(n.localizedTierName), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = te();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.token = i.string();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.planTokens.push(i.string());
          continue;
        case 3:
          if (d !== 24)
            break;
          t.numFreeTrialDays = i.uint32();
          continue;
        case 4:
          if (d !== 34)
            break;
          t.localizedTierName = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return $.fromPartial(n ?? {});
  },
  fromPartial(n) {
    var i;
    const e = te();
    return e.token = n.token ?? void 0, e.planTokens = ((i = n.planTokens) == null ? void 0 : i.map((r) => r)) || [], e.numFreeTrialDays = n.numFreeTrialDays ?? void 0, e.localizedTierName = n.localizedTierName ?? void 0, e;
  }
};
function ue() {
  return { $type: "squareup.sub2.data.ImmediateDowngrade", fromPlanToken: void 0, toPlanToken: void 0 };
}
const W = {
  $type: "squareup.sub2.data.ImmediateDowngrade",
  encode(n, e = u.Writer.create()) {
    return n.fromPlanToken !== void 0 && e.uint32(10).string(n.fromPlanToken), n.toPlanToken !== void 0 && e.uint32(18).string(n.toPlanToken), e;
  },
  decode(n, e) {
    const i = n instanceof u.Reader ? n : u.Reader.create(n);
    let r = e === void 0 ? i.len : i.pos + e;
    const t = ue();
    for (; i.pos < r; ) {
      const d = i.uint32();
      switch (d >>> 3) {
        case 1:
          if (d !== 10)
            break;
          t.fromPlanToken = i.string();
          continue;
        case 2:
          if (d !== 18)
            break;
          t.toPlanToken = i.string();
          continue;
      }
      if ((d & 7) === 4 || d === 0)
        break;
      i.skipType(d & 7);
    }
    return t;
  },
  create(n) {
    return W.fromPartial(n ?? {});
  },
  fromPartial(n) {
    const e = ue();
    return e.fromPlanToken = n.fromPlanToken ?? void 0, e.toPlanToken = n.toPlanToken ?? void 0, e;
  }
};
function pe(n) {
  if (n.gt(globalThis.Number.MAX_SAFE_INTEGER))
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  if (n.lt(globalThis.Number.MIN_SAFE_INTEGER))
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  return n.toNumber();
}
const re = () => {
  const n = u.util.Long;
  return u.util.Long = ae, u.configure(), () => {
    u.util.Long = n, u.configure();
  };
};
export {
  Ne as ActivationSource,
  Pe as ActiveTrial,
  Re as AvailableTrial,
  G as BaseRate,
  b as BaseRate_FeeRateConstraint,
  rn as BaseRate_FeeRateConstraint_Type,
  C as BucketPricing,
  se as Bundle,
  Te as BundleOffering,
  on as BundleOffering_AvailabilityStatus,
  U as BundlePlanUsageFixedDiscount,
  V as BundlePlanUsagePercentDiscount,
  v as BundlePriceAdjustment,
  S as BundlePricing,
  tn as Charge_ChargeStatus,
  Ie as ConsumedTrial,
  ce as DisplayedFeature,
  Z as DisplayedFeatureName,
  f as Duration,
  j as Duration_DurationUnit,
  Oe as EligibilityQualifier,
  ln as EligibilityQualifier_OnboardingEntryPoint,
  c as Entity,
  J as Entity_TokenType,
  N as ExternalPlan,
  z as Feature,
  Ae as Feedback,
  _ as FeedbackOption,
  _e as FeedbackOptionList,
  fn as FeedbackOption_InputType,
  I as FixedPricing,
  Y as HeadlineFeeRate,
  W as ImmediateDowngrade,
  B as LocalizedHeadlinePlanPricing,
  Q as ManagedBy,
  M as MultiBucketPricing,
  y as PercentDiscountBundlePriceAdjustment,
  an as PercentDiscountBundlePriceAdjustment_DiscountedComponentType,
  P as Plan,
  T as PlanChange,
  oe as PlanComponent,
  x as PlanFixedDiscountBundlePriceAdjustment,
  Ee as PlanGroup,
  $ as PlanGroupTier,
  H as PlanPercentDiscountBundlePriceAdjustment,
  nn as Plan_AvailabilityStatus,
  l as Pricing,
  O as ProductOwner,
  w as ProductOwner_OwnerType,
  F as Product_PayType,
  D as RetailPricing,
  R as SaasMoney,
  L as SingleUnitUsage,
  Se as SquareOneEligibility,
  cn as SquareOneEligibility_IneligibilityReason,
  fe as Subscription,
  le as SubscriptionKey,
  dn as Subscription_BillingStatus,
  K as SuperPOSMode,
  p as TieredPricing,
  en as TieredPricing_Calculation,
  s as TieredPricing_Tier,
  m as UnavailableReason,
  un as UnavailableReason_UnavailableReasonCode,
  A as Usage,
  k as UsageBucket,
  X as UsageUnitType
};
